{
  "common": {
    "save": "Save",
    "saving": "Saving...",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "add": "Add",
    "search": "Search...",
    "close": "Close",
    "back": "Back",
    "backToHome": "Back to home",
    "download": "Download",
    "downloading": "Downloading...",
    "viewAll": "View all →",
    "active": "Active",
    "inactive": "Inactive",
    "status": "Status",
    "date": "Date",
    "reference": "Reference",
    "amount": "Amount",
    "actions": "Actions",
    "loading": "Loading...",
    "error": "Error",
    "retry": "Retry",
    "noResults": "No results",
    "select": "Select...",
    "allStatuses": "All statuses",
    "all": "All",
    "yes": "Yes",
    "no": "No",
    "viewDetails": "View details",
    "name": "Name",
    "email": "Email",
    "phone": "Phone",
    "address": "Address",
    "city": "City",
    "postalCode": "Postal code",
    "siren": "SIREN",
    "erp": "ERP",
    "type": "Type",
    "description": "Description",
    "comment": "Comment",
    "other": "Other",
    "none": "-",
    "filterByErp": "Filter by ERP:",
    "users": "Users",
    "sendRequest": "Send request",
    "sending": "Sending...",
    "logout": "Logout",
    "client": "Client",
    "exportCsv": "Export CSV",
    "importCsv": "Import CSV",
    "optional": "Optional",
    "firstname": "First name",
    "lastname": "Last name",
    "password": "Password",
    "confirm": "Confirm"
  },
  "nav": {
    "dashboard": "Dashboard",
    "invoices": "Invoices",
    "orders": "Orders",
    "shipments": "Shipments",
    "tickets": "Support",
    "catalog": "Catalog",
    "projects": "Projects",
    "proposals": "Quotes",
    "gallery": "Documents",
    "revisions": "Revisions",
    "admin": "Administration",
    "erps": "Suppliers",
    "suppliers": "Customers",
    "users": "Users",
    "logs": "Logs",
    "registrations": "Registrations",
    "groups": "Groups",
    "collapseSidebar": "Collapse menu",
    "expandSidebar": "Expand menu",
    "pendingOrders": "Guest orders",
    "adminProposals": "Quotes & Signatures",
    "adminRevisions": "Product Revisions",
    "adminProducts": "Catalog",
    "adminUsage": "Usage",
    "adminBilling": "Subscriptions",
    "tarifs": "Subscription",
    "myTeam": "My team",
    "myPayments": "My payments",
    "mesCredits": "My credits",
    "adminProfile": "My profile",
    "erpSettings": "ERP Settings",
    "adminMigration": "ERP Migration",
    "sectionConfig": "General Configuration",
    "adminHelpTooltips": "Help Tooltips",
    "adminNotificationRules": "Notification Rules",
    "documentSignatures": "Signatures",
    "document_signatures": "Signatures"
  },
  "login": {
    "subtitle": "Sign in to your account",
    "email": "Email address",
    "emailPlaceholder": "your@email.com",
    "password": "Password",
    "submit": "Sign in",
    "loading": "Signing in...",
    "forgotPassword": "Forgot password?",
    "registerRequest": "Request access",
    "supplierSubtitle": "Sign in to your customer portal",
    "insertPassword": "Insert your password"
  },
  "forgotPassword": {
    "title": "Forgot password",
    "subtitle": "Enter your email address to receive a password reset link.",
    "email": "Email address",
    "submit": "Send link",
    "loading": "Sending...",
    "success": "A reset email has been sent if this account exists.",
    "backToLogin": "Back to login"
  },
  "resetPassword": {
    "title": "New password",
    "subtitle": "Choose a new secure password.",
    "password": "New password",
    "confirm": "Confirm password",
    "submit": "Reset",
    "loading": "Resetting...",
    "success": "Password successfully reset.",
    "errorMatch": "Passwords do not match.",
    "backToLogin": "Back to login"
  },
  "register": {
    "subtitle": "Registration request",
    "chooseTypeLabel": "What type of registration are you requesting?",
    "typeSupplier": "I am a supplier",
    "typeSupplierDesc": "I want to create my customer portal as a supplier",
    "typeClient": "I am a customer",
    "typeClientDesc": "I want to access my supplier's customer portal",
    "companyName": "Company name *",
    "siren": "SIREN *",
    "sirenPlaceholder": "e.g. 123 456 789",
    "lastname": "Last name *",
    "firstname": "First name *",
    "email": "Email *",
    "phone": "Phone *",
    "phonePlaceholder": "e.g. +44 7700 900000",
    "erpType": "ERP type *",
    "selectErp": "-- Select --",
    "commentLabel": "Comment",
    "erpBrandLabel": "ERP brand and version *",
    "erpBrandHint": "Please specify the brand and version of your ERP",
    "erpBrandPlaceholder": "e.g. SAP Business One 10.0",
    "submit": "Send request",
    "loading": "Sending...",
    "alreadyAccount": "Already have an account? Sign in",
    "captchaLabel": "Anti-bot verification *",
    "captchaQuestion": "How much is {{a}} + {{b}}?",
    "captchaPlaceholder": "Your answer",
    "captchaError": "Incorrect answer, please try again",
    "client": {
      "supplierSection": "Supplier information",
      "clientSection": "Your information",
      "supplierName": "Supplier name *",
      "supplierNamePlaceholder": "Search or type the supplier name...",
      "supplierSiren": "Supplier SIREN *",
      "supplierRequired": "Supplier name is required",
      "knownSupplier": "Registered",
      "supplierNotFound": "Supplier not found — type the name freely",
      "clientSiren": "Your company SIREN (optional)"
    }
  },
  "dashboard": {
    "adminTitle": "Welcome to the administration portal",
    "adminMessage": "Your administrator account is not linked to a supplier. Use the <strong>Administration</strong> menu to manage suppliers, customers and portal users.",
    "adminButton": "Administration",
    "unpaidInvoices_one": "{{count}} invoice awaiting payment",
    "unpaidInvoices_other": "{{count}} invoices awaiting payment",
    "viewInvoices": "View invoices",
    "invoices": "Invoices",
    "orders": "Orders",
    "shipments": "Shipments",
    "openTickets": "Open tickets",
    "recentInvoices": "Recent invoices",
    "recentOrders": "Recent orders",
    "noInvoices": "No invoices",
    "noOrders": "No orders",
    "paid": "Paid",
    "pending": "Pending"
  },
  "invoices": {
    "loadError": "Unable to load invoices.",
    "totalInvoices": "Total invoices",
    "totalAmount": "Total amount",
    "outstanding": "Outstanding",
    "searchPlaceholder": "Search an invoice...",
    "filterAll": "All statuses",
    "filterPaid": "Paid",
    "filterUnpaid": "Unpaid",
    "filterDraft": "Drafts",
    "colRef": "Reference",
    "colDate": "Date",
    "colDue": "Due date",
    "colAmount": "Amount",
    "colStatus": "Status",
    "colActions": "Actions",
    "notFound": "No invoices found",
    "statusPaid": "Paid",
    "statusUnpaid": "Unpaid",
    "statusDraft": "Draft",
    "statusCancelled": "Cancelled"
  },
  "lineItems": {
    "title": "Lines",
    "colRef": "Ref.",
    "colDescription": "Description",
    "colQty": "Qty",
    "colUnitPrice": "Unit price",
    "colTotal": "Total excl. tax",
    "colVat": "VAT",
    "noLines": "No lines",
    "moreLines": "+ {{count}} more line(s)",
    "previewLoading": "Loading lines...",
    "addToCart": "Add to cart"
  },
  "invoiceDetail": {
    "notFound": "Invoice not found",
    "backToList": "← Back to invoices",
    "title": "Invoice {{ref}}",
    "issuedOn": "Issued on {{date}}",
    "downloadPdf": "Download PDF",
    "downloading": "Downloading...",
    "addInvoiceToCart": "Re-add to cart",
    "customer": "Customer",
    "generalInfo": "General information",
    "invoiceDate": "Invoice date",
    "dueDate": "Due date",
    "creationDate": "Creation date",
    "customerRef": "Customer reference",
    "amounts": "Amounts",
    "totalExclTax": "Total excl. tax",
    "vat": "VAT",
    "totalInclTax": "Total incl. tax",
    "remaining": "Remaining",
    "notes": "Notes",
    "paAlreadySubmitted": "Already submitted",
    "paSubmitted": "submitted",
    "submitToPA": "Submit to PA"
  },
  "proposalDetail": {
    "notFound": "Quote not found",
    "backToList": "← Back to quotes",
    "title": "Quote {{ref}}",
    "createdOn": "Created on {{date}}",
    "downloadPdf": "Download PDF",
    "downloading": "Downloading...",
    "sign": "Sign",
    "signing": "Signing...",
    "generalInfo": "General information",
    "proposalDate": "Quote date",
    "validityDate": "Validity date",
    "creationDate": "Creation date",
    "customerRef": "Customer reference",
    "amounts": "Amounts",
    "totalExclTax": "Total excl. tax",
    "vat": "VAT",
    "totalInclTax": "Total incl. tax",
    "notes": "Notes",
    "multiClientError": "Quote detail is not available in multi-client mode. Please select a client using the search bar.",
    "sendForSignature": "Send for signature",
    "sendingForSignature": "Sending...",
    "customer": "Customer",
    "sendForSignatureSuccess": "The signing link for quote {{ref}} has been sent to the customer.",
    "signPolling": "Checking signature status for quote {{ref}}…",
    "signedTitle": "Quote {{ref}} signed",
    "signedBody": "The electronic signature has been successfully recorded."
  },
  "shipmentDetail": {
    "notFound": "Shipment not found",
    "backToList": "← Back to shipments",
    "title": "Shipment {{ref}}",
    "createdOn": "Created on {{date}}",
    "generalInfo": "General information",
    "creationDate": "Creation date",
    "deliveryDate": "Delivery date",
    "trackingTitle": "Package tracking",
    "trackPackage": "Track package",
    "notes": "Notes",
    "multiClientError": "Shipment detail is not available in multi-client mode. Please select a client using the search bar."
  },
  "orders": {
    "loadError": "Unable to load orders.",
    "totalOrders": "Total orders",
    "totalAmount": "Total amount",
    "searchPlaceholder": "Search an order...",
    "colRef": "Reference",
    "colDate": "Date",
    "colDelivery": "Expected delivery",
    "colAmount": "Amount",
    "colStatus": "Status",
    "notFound": "No orders found",
    "statusDraft": "Draft",
    "statusValidated": "Validated",
    "statusInProgress": "Shipment in progress",
    "statusShipped": "Shipped",
    "statusCancelled": "Cancelled"
  },
  "orderDetail": {
    "notFound": "Order not found",
    "backToList": "← Back to orders",
    "title": "Order {{ref}}",
    "createdOn": "Created on {{date}}",
    "downloadPdf": "Download PDF",
    "downloading": "Downloading...",
    "generalInfo": "General information",
    "orderDate": "Order date",
    "creationDate": "Creation date",
    "deliveryDate": "Delivery date",
    "customerRef": "Customer reference",
    "amounts": "Amounts",
    "totalExclTax": "Total excl. tax",
    "vat": "VAT",
    "totalInclTax": "Total incl. tax",
    "billingStatus": "Billing status",
    "billed": "Invoiced",
    "notBilled": "Not invoiced",
    "notes": "Notes",
    "customer": "Customer",
    "pdfError": "No PDF data received from server",
    "pdfDownloadError": "Error downloading PDF",
    "addOrderToCart": "Re-add to cart"
  },
  "ticketDetail": {
    "backToList": "Back to tickets",
    "notFound": "Ticket not found",
    "loadError": "Unable to load ticket.",
    "sendError": "Error sending message.",
    "trackId": "Track ID",
    "createdOn": "Created on",
    "type": "Type",
    "category": "Category",
    "priority": "Priority",
    "progress": "Progress",
    "description": "Description",
    "conversation": "Conversation",
    "noMessages": "No messages in the conversation",
    "support": "Support",
    "user": "User #{{id}}",
    "private": "Private",
    "messagePlaceholder": "Write a message...",
    "attachAudio": "Attach an audio file",
    "transcribing": "Transcribing...",
    "send": "Send",
    "closed": "This ticket is closed. You can no longer reply."
  },
  "shipments": {
    "loadError": "Unable to load shipments.",
    "totalShipments": "Total shipments",
    "searchPlaceholder": "Search a shipment or tracking number...",
    "colRef": "Reference",
    "colDate": "Date",
    "colDateCreation": "Created on",
    "colDateDelivery": "Delivery date",
    "colTracking": "Tracking number",
    "trackPackage": "Track package",
    "colStatus": "Status",
    "colAddress": "Address",
    "notFound": "No shipments found",
    "statusDraft": "Draft",
    "statusValidated": "Validated",
    "statusClosed": "Closed",
    "statusCancelled": "Cancelled"
  },
  "tickets": {
    "openTickets": "Open tickets",
    "newTicket": "New ticket",
    "searchPlaceholder": "Search a ticket...",
    "colRef": "Reference",
    "colSubject": "Subject",
    "colDate": "Created on",
    "colStatus": "Status",
    "colProgress": "Progress",
    "notFound": "No tickets found",
    "trackId": "Track ID: {{id}}",
    "modalTitle": "New support ticket",
    "subjectLabel": "Subject *",
    "subjectPlaceholder": "Briefly describe your request",
    "messageLabel": "Message *",
    "messagePlaceholder": "Describe your issue in detail...",
    "audioLabel": "Audio file (optional)",
    "audioButton": "Attach an audio file (service request)",
    "audioHint": "The file will be automatically transcribed and added to the ticket. Formats: mp3, wav, webm, m4a (max 25 MB)",
    "audioSizeError": "The audio file must not exceed 25 MB.",
    "typeLabel": "Type",
    "categoryLabel": "Category",
    "priorityLabel": "Priority",
    "typeIssue": "Issue",
    "typeQuestion": "Question",
    "typeRequest": "Request",
    "catTechnical": "Technical",
    "catBilling": "Billing",
    "catOther": "Other",
    "priLow": "Low",
    "priNormal": "Normal",
    "priHigh": "High",
    "priCritical": "Critical",
    "createError": "Error creating the ticket",
    "transcribing": "Transcribing...",
    "creating": "Creating...",
    "createButton": "Create ticket",
    "loadError": "Unable to load tickets.",
    "phoneSupport": "AI phone support available",
    "phoneSupportHint": "Our voice assistant can create your ticket in seconds. Call directly:"
  },
  "chatbot": {
    "title": "Support Assistant",
    "subtitle": "Guided ticket creation",
    "openButton": "Create with assistant",
    "defaultWelcome": "Hello! I will help you create your support request.",
    "describePrompt": "Describe your issue. I will analyse your description and only ask the necessary questions.",
    "descriptionPlaceholder": "E.g. My fire extinguisher model XY-42 installed in 2022 broke down on March 12th, there is a gas leak...",
    "extracting": "Analysing your description...",
    "extractedFields": "Information identified:",
    "missingFields": "Thank you!",
    "askField": "Could you tell me {{field}}?",
    "noExtraction": "Thank you!",
    "extractionFailed": "Thank you!",
    "statusAnalysing": "Analysing...",
    "autoFilled": "{{count}} field(s) auto-filled",
    "defaultSubject": "Support request",
    "loadError": "Unable to load the chatbot. Please use the standard form.",
    "inputPlaceholder": "Your answer...",
    "listeningPlaceholder": "Speak now...",
    "skip": "Skip",
    "voiceOn": "Enable voice mode",
    "voiceOff": "Disable voice mode",
    "voiceActive": "Voice mode on — questions are read aloud",
    "statusSpeaking": "Speaking...",
    "statusListening": "Listening — speak now",
    "question": "Question {{current}} / {{total}}",
    "summaryIntro": "Here is a summary of your request:",
    "confirmPrompt": "Would you like to create the ticket with this information?",
    "confirm": "Create ticket",
    "modify": "Start over",
    "editAnswer": "Edit answer",
    "reviewPrompt": "Is there anything you would like to add or change?",
    "reviewYes": "Yes, I want to modify",
    "reviewNo": "No, it's correct",
    "reviewInputPrompt": "Describe what you would like to add or change.",
    "reviewInputPlaceholder": "Clarify or correct information...",
    "reviewDirectPlaceholder": "Or type your correction directly...",
    "summaryCorrectPlaceholder": "Correct (e.g. change name to Michel)...",
    "reviewExtracting": "Updating your request...",
    "reviewUpdated": "Information updated:",
    "reviewNoValueFound": "I could not find a new value in your message. Could you be more specific, e.g. \"change the time to 10:00\"?",
    "summaryVoiceHint": "Say confirm to submit, or describe a change.",
    "validationTime": "Invalid time format. Examples: 8h30, 14:00, 08:30",
    "validationDate": "Invalid date format. Examples: 25/03/2026, 2026-03-25",
    "validationNumber": "Please enter a numeric value",
    "validationEmail": "Invalid email address",
    "validationPhone": "Invalid phone number (8–15 digits expected)",
    "validationGeneric": "The entered value is not valid",
    "placeholderTime": "e.g. 8h30 or 14:00",
    "placeholderNumber": "e.g. 42",
    "placeholderEmail": "e.g. name@domain.com",
    "placeholderPhone": "e.g. +44 7700 900000",
    "restart": "OK, let's start over.",
    "submitting": "Creating ticket...",
    "ticketCreated": "Ticket created successfully.",
    "submitError": "An error occurred while creating the ticket. Please try again.",
    "close": "Close"
  },
  "catalog": {
    "title": "Catalog",
    "subtitle": "{{count}} references available",
    "cart": "Cart",
    "searchPlaceholder": "Search a product or service...",
    "notFound": "No products found",
    "ref": "Ref: {{ref}}",
    "typeProduct": "Product",
    "typeService": "Service",
    "priceExclTax": "Price excl. tax",
    "priceInclTax": "Price incl. tax",
    "inStock": "In stock: {{count}}",
    "outOfStock": "Out of stock",
    "documentation": "Documentation",
    "productWebsite": "View on website",
    "viewDoc": "View",
    "downloadDoc": "Download",
    "addedToCart": "Added to cart",
    "addToCart": "Add to cart",
    "loadError": "Unable to load products. Please try again later.",
    "docsModalTitle": "Documentation",
    "noDocsAvailable": "No documents available for this product",
    "filterAll": "All products",
    "filterPurchased": "Recently purchased",
    "loadingMore": "Loading more...",
    "noMoreProducts": "All products are displayed",
    "chooseVariant": "Choose a variant",
    "selectVariant": "Select a variant",
    "noVariants": "No variants available for this product."
  },
  "cart": {
    "title": "Cart",
    "empty": "Your cart is empty",
    "browseProducts": "Browse catalog",
    "product": "Product",
    "quantity": "Quantity",
    "unitPrice": "Unit price",
    "total": "Total",
    "orderTotal": "Order total",
    "placeOrder": "Place order",
    "ordering": "Ordering...",
    "orderSuccess": "Order placed successfully!",
    "orderError": "Error creating the order.",
    "remove": "Remove",
    "continueShop": "Continue shopping",
    "excl": "excl. tax",
    "incl": "incl. tax",
    "totalExclTax": "Total excl. tax",
    "totalInclTax": "Total incl. tax",
    "stockError": "Insufficient stock for one or more products. Please check availability and try again."
  },
  "documents": {
    "title": "Documents",
    "totalDocuments": "Total documents",
    "showing": "showing: {{count}} / {{total}}",
    "searchPlaceholder": "Search a document or reference...",
    "filterAll": "All types",
    "filterSociete": "Company",
    "filterInvoices": "Invoices",
    "filterOrders": "Orders",
    "filterShipments": "Shipments",
    "filterTickets": "Tickets",
    "notFound": "No documents found",
    "noneAvailable": "No documents available",
    "loadError": "Unable to load documents. Please try again later.",
    "labelType": "Type",
    "labelSize": "Size",
    "labelDate": "Date",
    "moduleSociete": "Company",
    "moduleInvoice": "Invoice",
    "moduleOrder": "Order",
    "moduleShipment": "Shipment",
    "moduleTicket": "Ticket"
  },
  "proposals": {
    "title": "Quotes",
    "subtitle_one": "{{count}} quote",
    "subtitle_other": "{{count}} quotes",
    "notFound": "No quotes available",
    "noneFound": "No quotes match the selected filters",
    "searchPlaceholder": "Search a quote...",
    "loadError": "Unable to load quotes.",
    "colRef": "Reference",
    "colDate": "Date",
    "colValidity": "Validity",
    "colAmountExcl": "Amount excl. tax",
    "colAmountIncl": "Amount incl. tax",
    "colStatus": "Status",
    "colActions": "Actions",
    "customerRef": "Customer ref: {{ref}}",
    "downloadPdf": "Download PDF",
    "sign": "Sign",
    "signTitle": "Sign quote",
    "signConfirm": "Do you want to initiate electronic signing of quote {{ref}}?",
    "signError": "Error requesting signature. Please try again.",
    "signSuccessTitle": "Signing invitation created for quote {{ref}}",
    "signSuccessBody": "An email with the signing link has been sent to you. You can also sign directly from this page:",
    "signNow": "Sign now",
    "statusCancelled": "Cancelled",
    "statusDraft": "Draft",
    "statusValidated": "Validated",
    "statusSigned": "Signed",
    "statusUnsigned": "Not signed",
    "statusUnknown": "Unknown",
    "signPolling": "Checking signature status for quote {{ref}}…",
    "signedTitle": "Quote {{ref}} signed",
    "signedBody": "The electronic signature has been successfully recorded."
  },
  "proposalSignature": {
    "title": "Send for signature",
    "subtitle": "Select the recipient contact for quote {{ref}}",
    "noContacts": "No contact or email address was found for this quote or its company in the ERP. Please define a contact or email address on the third-party in the ERP before sending.",
    "loadError": "Unable to load contacts for this quote.",
    "sendError": "Error sending the invitation.",
    "contactFound": "Contact",
    "selectContact": "Select a contact",
    "send": "Send invitation",
    "sent": "Invitation sent successfully!"
  },
  "adminProposals": {
    "title": "Quotes & Signatures",
    "selectCustomer": "Select a customer to display their quotes",
    "searchCustomer": "Search a customer...",
    "noProposals": "No quotes found for this customer",
    "sendInvite": "Send invitation",
    "resend": "Resend",
    "confirmSend": "Send an electronic signature invitation for quote {{ref}} to {{email}}?",
    "inviteSent": "Invitation sent to {{email}}",
    "colRef": "Reference",
    "colDate": "Date",
    "colValidity": "Validity",
    "colTotal": "Total excl. tax",
    "colStatus": "ERP status",
    "colSignature": "Signature",
    "sigNone": "Not sent",
    "sigPending": "Pending",
    "sigSigned": "Signed",
    "sigRefused": "Refused",
    "sigExpired": "Expired",
    "downloadPdf": "Download PDF",
    "viewSigned": "Signed doc"
  },
  "projects": {
    "title": "Projects",
    "totalProjects": "Total projects",
    "searchPlaceholder": "Search a project...",
    "notFound": "No projects found",
    "loadError": "Unable to load projects.",
    "statusDraft": "Draft",
    "statusValidated": "Validated",
    "statusClosed": "Closed",
    "statusUnknown": "Unknown",
    "colRef": "Reference",
    "colTitle": "Title",
    "colDate": "Date",
    "colDateStart": "Start date",
    "colDateEnd": "End date",
    "colBudget": "Budget",
    "colStatus": "Status",
    "colProgress": "Progress"
  },
  "gallery": {
    "filterAll": "All",
    "filterImages": "Images",
    "filterFiles": "Files",
    "searchPlaceholder": "Search...",
    "items_one": "{{count}} item",
    "items_other": "{{count}} items",
    "allModules": "All modules",
    "notFound": "No documents found",
    "download": "Download",
    "moduleSociete": "Supplier",
    "moduleInvoice": "Invoice",
    "moduleOrder": "Order",
    "moduleShipment": "Shipment",
    "moduleTicket": "Support",
    "moduleProposal": "Quote",
    "moduleProject": "Project",
    "loadMore": "Load more ({{remaining}} remaining)"
  },
  "revisions": {
    "title": "Product Revisions",
    "subtitle": "Track revision deadlines for your products",
    "colProduct": "Product",
    "colLastPurchase": "Last Purchase",
    "colNextRevision": "Next Revision",
    "colStatus": "Status",
    "colAction": "Action",
    "statusOk": "Up to date",
    "statusDue": "Due soon",
    "statusOverdue": "Overdue",
    "acknowledge": "Confirm completion",
    "acknowledged": "Completion confirmed",
    "noRevisions": "No revisions scheduled",
    "noPurchase": "Never purchased",
    "loadError": "Error loading revisions",
    "confirmAck": "Confirm that the revision for \"{{label}}\" has been completed?",
    "ackSuccess": "Revision confirmed",
    "ackError": "Error confirming revision"
  },
  "adminRevisions": {
    "title": "Product Revisions",
    "tabRules": "Revision Rules",
    "tabSchedules": "Schedule",
    "syncBtn": "Sync from ERP",
    "syncSuccess": "Sync complete ({{count}} entries)",
    "syncError": "Sync error",
    "ruleProduct": "Product Reference",
    "ruleLabel": "Revision Label",
    "ruleInterval": "Interval (days)",
    "ruleErp": "ERP",
    "ruleActive": "Active",
    "addRule": "Add Rule",
    "editRule": "Edit Rule",
    "deleteRule": "Delete Rule",
    "deleteConfirm": "Delete this revision rule?",
    "colCustomer": "Customer",
    "colStatus": "Status",
    "colLastPurchase": "Last Purchase",
    "colNextRevision": "Next Revision",
    "filterAll": "All statuses",
    "noSchedules": "No revisions in schedule",
    "noRules": "No revision rules configured"
  },
  "shop": {
    "title": "Online Store",
    "titleFor": "Store — {{name}}",
    "subtitle_one": "{{count}} product available",
    "subtitle_other": "{{count}} products available",
    "subtitle": "{{count}} products available",
    "searchPlaceholder": "Search for a product...",
    "notFound": "No products found",
    "loadError": "Unable to load products. Please try again later.",
    "shopDisabledTitle": "Shop temporarily unavailable",
    "shopDisabledMessage": "The online shop for this supplier is not currently available.",
    "cart": "Cart",
    "cartTitle": "My cart",
    "cartEmpty": "Your cart is empty",
    "checkout": "Checkout",
    "checkoutTitle": "Complete your order",
    "checkoutInfo": "To place your order, please sign in to your customer portal or create an account.",
    "loginTitle": "Sign in",
    "loginAndOrder": "Sign in and order",
    "loginError": "Incorrect credentials. Please try again.",
    "noAccount": "Don't have an account yet?",
    "registerLink": "Request access",
    "tabLogin": "Sign in",
    "tabGuest": "Order without an account",
    "guestFirstname": "First name",
    "guestLastname": "Last name",
    "guestEmail": "Email",
    "guestPhone": "Phone",
    "guestCompany": "Company",
    "guestSiren": "SIREN (optional)",
    "guestNotes": "Notes (optional)",
    "guestSubmit": "Send my order",
    "guestSending": "Sending...",
    "guestSuccessTitle": "Order received!",
    "guestSuccessDetail": "Your order request has been saved. A confirmation email has been sent to you. Your order will be processed once your registration has been approved.",
    "guestError": "An error occurred. Please try again.",
    "categoryAll": "All categories"
  },
  "mesCredits": {
    "title": "My credits",
    "refresh": "Refresh",
    "balance": "Available credit balance",
    "creditsUnit": "credits",
    "balanceHint": "Used only for consumption beyond your quotas.",
    "creditsRule": "€1 = 1,000 credits",
    "lowBalance": "Low balance — top up your account to avoid interruption",
    "recharge": "Top up",
    "chooseAmount": "Choose amount",
    "customAmount": "Custom amount:",
    "amountHint": "Minimum €10 excl. tax — VAT applicable",
    "continue": "Continue — {{amount}} € excl. tax",
    "loading": "Loading…",
    "securePayment": "Secure payment",
    "amountHT": "Amount excl. tax",
    "vat": "VAT ({{rate}}%)",
    "totalTTC": "Total incl. tax",
    "payBtn": "Pay {{amount}} € incl. tax",
    "processing": "Processing…",
    "retryPayment": "Restart with a new payment",
    "paymentSuccess": "Payment confirmed!",
    "paymentSuccessMsg": "Your account has been credited. New balance:",
    "quotaTitle": "Current month quotas",
    "unlimited": "Unlimited",
    "esignatures": "Electronic signatures",
    "emails": "Emails",
    "aiTokens": "AI tokens",
    "quotaWarning": "You are approaching your limits on: {{resources}}. Consider upgrading your plan.",
    "historyTitle": "Recent history",
    "noTransactions": "No transactions",
    "colDescription": "Description",
    "colCredits": "Credits",
    "paymentError": "Payment error",
    "creditError": "Payment confirmed but error while crediting. Contact support.",
    "loadError": "Error loading",
    "initError": "Error initializing payment"
  },
  "profile": {
    "title": "My Account",
    "sectionIdentity": "Identity",
    "sectionPassword": "Change password",
    "firstName": "First Name",
    "lastName": "Last Name",
    "passwordMismatch": "The passwords do not match.",
    "subtitle": "Your account information",
    "loadError": "Unable to load the profile.",
    "saveError": "Error while saving.",
    "saveSuccess": "Profile saved.",
    "save": "Save",
    "saving": "Saving…",
    "email": "Email",
    "passwordHint": "Leave blank to keep the current password.",
    "password": "Password",
    "newPassword": "New Password",
    "confirmPassword": "Confirm your password"
  },
  "tarifs": {
    "title": "Subscription",
    "subtitle": "View your current subscription and choose the pack that suits your needs.",
    "quota": {
      "users": "Users",
      "clients": "Clients",
      "signatures": "Signatures",
      "aiTokens": "AI tokens",
      "emails": "Emails/month",
      "catalog": "Online catalog products"
    },
    "planCard": {
      "currentPlan": "Current plan",
      "onQuote": "On quote",
      "customQuotas": "Custom quotas",
      "customValue": "Custom",
      "contactUs": "Contact us",
      "perPackPerMonth": "/pack/month",
      "billingMonthly": "excl. tax — monthly billing",
      "selected": "Selected",
      "choosePlan": "Choose this plan"
    },
    "proration": {
      "planChange": "Plan change",
      "newPlan": "New plan ({{name}})",
      "proratedCredit": "Prorated credit ({{remaining}}d / {{total}}d)",
      "amountDueHT": "Amount due excl. tax",
      "vat": "VAT ({{rate}}%)",
      "totalTTC": "Total incl. tax today",
      "fromDate": "From {{date}}: {{price}} € excl. tax / month",
      "restart": "Restart",
      "paying": "Processing…",
      "pay": "Pay {{amount}} € incl. tax",
      "activationError": "Payment confirmed but error during activation. Contact support.",
      "stripeError": "Payment error"
    },
    "cart": {
      "empty": "Select a plan to get started",
      "yourOrder": "Your order",
      "packCount": "Number of packs",
      "effectiveQuotas": "Effective quotas",
      "totalHT": "Total excl. tax / month",
      "vat": "VAT (20%)",
      "totalTTC": "Total incl. tax / month",
      "processing": "Processing…",
      "order": "Order",
      "billingInfo": "Monthly billing — cancel anytime"
    },
    "sub": {
      "customPlan": "Custom plan",
      "monthly": "Monthly subscription",
      "active": "Active",
      "dueDate": "Due date",
      "nextBilling": "Next billing",
      "creditBalance": "Credit balance",
      "effectiveQuotas": "Effective quotas",
      "noSubscription": "No active subscription. Choose a plan below to get started.",
      "pack_one": "{{count}} pack",
      "pack_other": "{{count}} packs",
      "editQty": "Edit number of packs (currently {{packs}})",
      "editQtyTitle": "Edit number of packs",
      "confirm": "Confirm",
      "inProgress": "In progress…",
      "pendingChangeTitle": "Scheduled change:",
      "pendingChangeBody": "switch to plan {{name}}{{packs}} on {{date}}. Your current plan remains active until then.",
      "pendingPacks": " × {{count}} packs"
    },
    "plans": {
      "changePlan": "Change plan",
      "choosePlan": "Choose your plan",
      "noPlans": "No plans available at the moment.",
      "howTitle": "How do packs work?",
      "howDesc1": "Each pack gives you access to the indicated quotas (users, clients, signatures, AI tokens, emails).",
      "howDesc2": "You can purchase multiple packs to multiply your quotas proportionally."
    },
    "msg": {
      "nextBillingDate": "the next billing date",
      "scheduleDowngrade": "The downgrade to plan \"{{name}}\" will take effect on {{date}}. Your current plan remains active until then.",
      "subscriptionActivated": "Subscription \"{{name}}\" activated successfully!",
      "planActivated": "Plan \"{{name}}\" activated successfully!",
      "subscriptionError": "Error during subscription.",
      "connectionError": "Connection error. Please try again.",
      "qtyReduced_one": "The reduction to {{count}} pack will take effect on {{date}}.",
      "qtyReduced_other": "The reduction to {{count}} packs will take effect on {{date}}.",
      "qtyUpdated_one": "Quantity updated: {{count}} pack.",
      "qtyUpdated_other": "Quantity updated: {{count}} packs.",
      "modifyError": "Error during modification."
    }
  },
  "admin": {
    "erpImpersonation": {
      "title": "View as ERP admin",
      "select": "ERP admin mode",
      "viewAll": "View all (super_admin)",
      "banner": "Viewing as administrator of ERP: {{name}}",
      "exit": "Exit this mode"
    },
    "dashboard": {
      "title": "Administration",
      "recentActivity": "Recent activity",
      "viewAll": "View all",
      "noActivity": "No recent activity",
      "erps": "Suppliers",
      "suppliers": "Customers",
      "users": "Users",
      "activeUsers": "Active users",
      "schemaMismatchTitle": "Incompatible database version",
      "schemaMismatchDesc": "The database schema is at version {{db}}, but the code requires version {{required}}. Please apply the corresponding migration script.",
      "schemaMismatchRequired": "required",
      "pendingOrdersAlertTitle": "{{count}} guest order(s) awaiting processing",
      "pendingOrdersAlertDesc": "Unregistered customers have placed orders from the public shop. Please process them.",
      "pendingOrdersAlertAction": "View orders"
    },
    "erps": {
      "title": "Supplier Management",
      "fields": {
        "common": {
          "api_key": "API Key",
          "api_secret": "API Secret",
          "api_version": "API Version"
        },
        "dolibarr": {
          "base_url": "Dolibarr Base URL",
          "base_url_help": "Root URL of your Dolibarr instance, WITHOUT /api/index.php. The portal will automatically append /api/index.php to requests.",
          "api_key": "API Key (DOLAPIKEY)",
          "api_key_help": "API key of a Dolibarr user. Menu: Home > Setup > Users > [user] > \"API / Webservices\" tab."
        },
        "salesforce": {
          "base_url": "Instance URL",
          "base_url_help": "Your Salesforce instance URL (without /services/). Found in Setup > Company Information.",
          "api_key": "Client ID (Connected App)",
          "api_key_help": "Consumer Key of your Salesforce Connected App. Setup > App Manager > Connected Apps.",
          "api_secret": "Client Secret",
          "api_secret_help": "Consumer Secret of your Salesforce Connected App.",
          "api_version": "API Version (e.g. v59.0)",
          "api_version_help": "Salesforce REST API version to use.",
          "oauth2Title": "Salesforce OAuth2 Configuration",
          "sf_username": "API Username",
          "sf_password": "Password + Security Token",
          "sf_password_placeholder": "password + security token concatenated",
          "sf_password_help": "Concatenate your password and your Salesforce Security Token"
        },
        "business_central": {
          "base_url": "Business Central API URL",
          "base_url_help": "Base URL of the Business Central OData v4 API.",
          "api_key": "Client ID (Azure AD)",
          "api_key_help": "Application (client) ID of your Azure AD app registration.",
          "api_secret": "Client Secret (Azure AD)",
          "api_secret_help": "Client secret value created in Azure AD > Certificates & secrets.",
          "api_version_help": "Business Central API version.",
          "azureTitle": "Azure AD / Business Central Configuration",
          "bc_tenant_id": "Tenant ID (Azure AD)",
          "bc_environment": "Environment",
          "bc_company_id": "Company ID",
          "bc_company_id_help": "Company GUID (optional if only one)"
        },
        "csv": {
          "base_url": "Data directory path",
          "base_url_help": "Absolute path of the directory containing the CSV files (invoices.csv, orders.csv, etc.) on the server."
        },
        "default": {
          "base_url": "Base URL",
          "base_url_help": "Root URL of your ERP API (without the API path, which will be appended automatically).",
          "api_key_help": "API authentication key provided by your ERP.",
          "api_secret_help": "API authentication secret."
        },
        "odoo": {
          "base_url": "Odoo Base URL",
          "base_url_help": "Root URL of your Odoo instance (e.g. http://localhost:8069). No trailing slash.",
          "api_key": "Odoo API Key",
          "api_key_help": "API key generated in Odoo: Settings > Technical > API Keys. Used as the password for JSON-RPC authentication.",
          "api_secret": "Odoo Login (account email)",
          "api_secret_help": "Email address of the Odoo account linked to the API key (e.g. admin@mycompany.com). Used as the login for JSON-RPC authentication.",
          "api_version_help": "Version of your Odoo instance (e.g. 17.0). Used to adapt certain API calls based on the version."
        },
        "bleez": {
          "base_url": "Bleez API URL",
          "base_url_help": "Bleez API base URL (usually https://api.bleez.com).",
          "api_key": "OAuth2 Client ID",
          "api_key_help": "OAuth2 client ID provided by Bleez support.",
          "api_secret": "OAuth2 Client Secret",
          "api_secret_help": "OAuth2 client secret provided by Bleez support.",
          "oauth2Title": "Bleez Login Credentials",
          "bleez_username": "Bleez Username",
          "bleez_password": "Bleez Password",
          "bleez_cle_encryptee": "Dossier Encrypted Key",
          "bleez_cle_encryptee_help": "Encrypted key of your Bleez dossier. Available in the Bleez back-office (dossier URL)."
        }
      },
      "addErp": "Add Supplier",
      "colType": "Type",
      "colLogo": "Logo",
      "colName": "Name",
      "colUrl": "URL",
      "colSuppliers": "Customers",
      "colStatus": "Status",
      "colDate": "Date",
      "colActions": "Actions",
      "none": "No supplier configured",
      "modalCreate": "Add Supplier",
      "modalEdit": "Edit Supplier",
      "fieldType": "Type",
      "fieldName": "Name",
      "fieldDescription": "Description",
      "fieldWebsite": "Supplier website",
      "fieldWebsiteHint": "Displayed as a clickable link on the logo in the customer sidebar",
      "fieldLogo": "Logo",
      "logoUpload": "Upload",
      "logoChange": "Change",
      "logoHint": "PNG, JPG or SVG (max 200 KB)",
      "logoSizeError": "Logo must not exceed 200 KB",
      "fieldActive": "Active",
      "shopSettings": "Online shop",
      "shopEnabled": "Enable public shop",
      "shopShowPrices": "Show prices in shop",
      "testConnection": "Test connection",
      "testOk": "Connection OK",
      "testFail": "Failed",
      "testSaveFirst": "Save the supplier first before testing the connection.",
      "enabledModules": "Enabled modules",
      "erpAdminNotice": "You can edit the description, logo, website, shop settings, enabled modules and chatbot. ERP connection, invoicing and telephony settings are managed by the super-administrator.",
      "connectionReadOnly": "ERP connection settings are managed by the super-administrator.",
      "colModule": "Module",
      "colLastTest": "Last test",
      "colActivatable": "Activatable",
      "colEnabled": "Enabled",
      "moduleNotTested": "Not tested",
      "sttVocabulary": "Audio transcription vocabulary",
      "sttVocabularyHint": "Business words or phrases separated by commas, to improve voice recognition",
      "sttVocabularyPlaceholder": "e.g. ERP, billing, purchase order, quote...",
      "chatbotTitle": "SAV Chatbot (guided ticket creation)",
      "chatbotHint": "Allows customers to create a support ticket by answering predefined questions",
      "chatbotEnabled": "Enabled",
      "chatbotWelcome": "Welcome message",
      "chatbotWelcomePlaceholder": "e.g. Hello! I will help you create your support request. Please answer the following questions.",
      "chatbotQuestions": "Questions to ask",
      "chatbotQuestionLabel": "Question text...",
      "chatbotTypeText": "Short text",
      "chatbotTypeTextarea": "Long text",
      "chatbotTypeDate": "Date",
      "chatbotTypeTime": "Time",
      "chatbotTypeNumber": "Number",
      "chatbotTypeEmail": "Email",
      "chatbotTypePhone": "Phone",
      "chatbotTypeSelect": "Multiple choice",
      "chatbotFieldSubject": "→ Ticket subject",
      "chatbotFieldMessage": "→ Message body",
      "chatbotFieldType": "→ Ticket type",
      "chatbotFieldCategory": "→ Category",
      "chatbotFieldSeverity": "→ Priority",
      "chatbotOptionsPlaceholder": "Options separated by commas (e.g. Option A, Option B, Option C)",
      "chatbotRequired": "Required",
      "chatbotAddQuestion": "Add a question",
      "vapiTitle": "Vapi.ai — AI phone support",
      "vapiHint": "Connect an AI phone number to let customers create tickets by voice call",
      "vapiEnabled": "Enabled",
      "vapiLanguage": "Language",
      "vapiVoiceProvider": "Text-to-speech",
      "vapiVoiceId": "Voice ID",
      "vapiPhoneNumber": "Vapi phone number",
      "vapiPhoneSelect": "— Select a phone number —",
      "vapiAssistantId": "Assistant ID (managed automatically)",
      "vapiSync": "Sync Vapi assistant",
      "vapiSyncSuccess": "Assistant synced successfully",
      "vapiSyncError": "Error syncing Vapi assistant",
      "deleteConfirm": "Delete supplier \"{{name}}\"?",
      "connectionSuccess": "Connection successful",
      "connectionFail": "Connection failed",
      "testModalTitle": "Connection test — {{name}}",
      "testTesting": "Testing...",
      "testConnectionStatus": "General connection",
      "testModuleAccess": "Module access",
      "testModuleCol": "Module",
      "testStatusCol": "Status",
      "testCountCol": "Items",
      "testModuleCount": "{{count}} items",
      "readOnlyMode": "Read-only view — contact a super administrator to modify the configuration",
      "fieldSiren": "SIREN",
      "sectionEinvoice": "Electronic invoicing (Factur-X)",
      "fieldSiret": "SIRET",
      "fieldVatNumber": "Intra-community VAT number",
      "fieldIban": "IBAN",
      "fieldBic": "BIC / SWIFT",
      "sectionPaConnector": "PA / PDP Connector (e-invoice submission)",
      "fieldPaProvider": "Approved Partner (PA/PDP)",
      "paNone": "— None —",
      "copyLoginLink": "Copy login link",
      "loginLinkCopied": "Link copied!",
      "copyShopLink": "Copy shop link",
      "shopLinkCopied": "Link copied!",
      "pageCreate": "Create a supplier",
      "pageEdit": "Edit supplier",
      "backToList": "Back to suppliers",
      "sectionGeneral": "General information",
      "sectionGeneralSubtitle": "Identity, logo and contact details of the supplier",
      "sectionConnection": "ERP Connection",
      "sectionConnectionSubtitle": "API access settings for your ERP",
      "sectionEinvoiceTitle": "Electronic invoicing",
      "sectionEinvoiceSubtitle": "Legal data for Factur-X and PA/PDP connectors",
      "sectionModules": "Shop & Modules",
      "sectionModulesSubtitle": "Enable or disable portal features",
      "sectionChatbot": "Chatbot & Telephony",
      "sectionChatbotSubtitle": "Configure the support chatbot and AI phone support",
      "sectionPayment": "Online payment",
      "sectionPaymentSubtitle": "Connect Stripe to allow invoice payments",
      "stripeSaveFirst": "Save the supplier first to configure Stripe payment.",
      "fieldSirenHint": "9-digit unique identifier — used for login and shop links",
      "fieldSirenHelp": "The SIREN is the company identifier (9 digits). It is used to generate login and public shop URLs for customers.",
      "fieldSiretHelp": "SIRET = SIREN (9 digits) + NIC (5 digits). Required for generating Factur-X electronic invoices.",
      "sirenSiretWarning": "SIREN and SIRET are recommended for electronic invoicing. Some features (Chorus Pro, e-invoice) may not work without this information.",
      "fieldVatNumberHelp": "Intra-community VAT number (e.g. FR12345678901). Required for cross-border B2B transactions and electronic invoicing.",
      "fieldIbanHelp": "Bank account in IBAN format (e.g. FR76 1234...). Included in Factur-X electronic invoices to facilitate payment.",
      "fieldBicHelp": "Bank BIC / SWIFT code (e.g. AGRIFRPP). Complements the IBAN for international transfers.",
      "fieldPaProviderHelp": "Select an Approved Partner (PA) or Partner Dematerialisation Provider (PDP) for automatic submission of electronic invoices.",
      "doc": {
        "dolibarr": {
          "title": "How to configure Dolibarr API access?",
          "step1": "Log in as an administrator on your Dolibarr instance",
          "step2": "Go to Home > Setup > Users > [user], tab API / Webservices",
          "step3": "Enable API access and copy the generated DOLAPIKEY",
          "link": "Dolibarr API documentation"
        },
        "salesforce": {
          "title": "How to configure a Salesforce Connected App?",
          "step1": "In Setup, search for App Manager and create a new Connected App",
          "step2": "Enable OAuth, add the required scopes, copy Consumer Key and Consumer Secret",
          "step3": "In Setup > Company Information, copy your Instance URL",
          "link": "Salesforce Connected Apps documentation"
        },
        "business_central": {
          "title": "How to configure Azure AD / Business Central access?",
          "step1": "In the Azure portal, create an app registration and copy the Application (client) ID",
          "step2": "Under Certificates & secrets, create a new client secret and copy its value",
          "step3": "In Business Central, grant API permissions to the Azure AD application",
          "link": "Business Central API documentation"
        },
        "odoo": {
          "title": "How to configure Odoo API access?",
          "step1": "Log in to Odoo and go to Settings > Technical > API Keys",
          "step2": "Create a new API key and copy it — it is used as the password for authentication",
          "step3": "Note the email address of the Odoo account linked to this key (used as login)",
          "link": "Odoo external API documentation"
        },
        "sage100": {
          "title": "How to configure Sage 100 API access?",
          "step1": "Open the Sage 100 administration console and enable the REST API server",
          "step2": "Create a dedicated API user with the required permissions",
          "step3": "Retrieve the Sage 100 server base URL and the API credentials"
        },
        "netsuite": {
          "title": "How to configure NetSuite API access?",
          "step1": "In NetSuite, go to Setup > Integration > Manage Integrations and create a new integration",
          "step2": "Enable Token-Based Authentication (TBA) and copy the Consumer Key and Consumer Secret",
          "step3": "Create an Access Token for the API user and note the Token ID and Token Secret",
          "link": "NetSuite REST API documentation"
        },
        "erpnext": {
          "title": "How to configure ERPNext / Frappe API access?",
          "step1": "Log in to ERPNext and go to My Profile > Generate Keys",
          "step2": "Copy the generated API key (api_key) and API secret (api_secret)",
          "step3": "Use your Frappe instance URL as the base URL (e.g. https://myerpnext.frappe.cloud)",
          "link": "Frappe API documentation"
        },
        "zoho": {
          "title": "How to configure Zoho One API access?",
          "step1": "Go to the Zoho Developer Console and create a new OAuth client",
          "step2": "Select Server-based Applications and copy the Client ID and Client Secret",
          "step3": "Authorize the necessary scopes and generate a refresh token for your account",
          "link": "Zoho CRM API documentation"
        },
        "cegid": {
          "title": "How to configure Cegid XRP Flex API access?",
          "step1": "In Cegid XRP Flex, go to Administration > API and enable REST API access",
          "step2": "Create a dedicated service account with the necessary read permissions",
          "step3": "Retrieve your Cegid tenant URL and the service account credentials"
        },
        "csv": {
          "title": "How to configure CSV import?",
          "step1": "Place your CSV files in a directory accessible by the web server",
          "step2": "Name them according to the convention: invoices.csv, orders.csv, catalog.csv, etc.",
          "step3": "Enter the absolute path of the directory in the Data directory path field"
        }
      }
    },
    "customers": {
      "title": "Customer Management",
      "addCustomer": "Add customer",
      "filterAll": "All",
      "colName": "Name",
      "colSiren": "SIREN",
      "colErp": "Supplier",
      "colErpId": "ERP ID",
      "colEmail": "Email",
      "colCity": "City",
      "colUsers": "Users",
      "colStatus": "Status",
      "colActions": "Actions",
      "none": "No customers",
      "modalCreate": "Add customer",
      "modalEdit": "Edit customer",
      "fieldErp": "Supplier",
      "fieldErpCustomerId": "Customer ID in ERP",
      "fieldName": "Customer name / Company",
      "fieldSiren": "SIREN",
      "fieldEmail": "Email",
      "fieldPhone": "Phone",
      "fieldAddress": "Address",
      "fieldCity": "City",
      "fieldPostalCode": "Postal code",
      "fieldActive": "Active",
      "selectErp": "-- Select --",
      "deleteConfirm": "Delete customer \"{{name}}\"?",
      "syncBtn": "Sync from ERP",
      "syncTitle": "Synchronize customers from ERP",
      "syncSelectErp": "ERP Supplier",
      "syncLimit": "Maximum customers to import",
      "syncPreview": "Analyze",
      "syncFoundCount": "{{count}} customer(s) available in ERP ({{synced}} already synced)",
      "syncSelectAll": "Select all",
      "syncDeselectAll": "Deselect all",
      "syncImport": "Import selection",
      "syncSuccess": "{{imported}} customer(s) imported, {{skipped}} skipped.",
      "syncNone": "All ERP customers are already in the portal.",
      "syncHint": "Only third-parties flagged as customers in the ERP are listed.",
      "syncFilters": "Filter criteria",
      "syncFilterInvoices": "With recent invoices",
      "syncFilterProposals": "With recent proposals",
      "syncFilterMonths": "{{n}} month(s)",
      "erpSearch": "Search in ERP",
      "erpSearchPlaceholder": "Type company name...",
      "erpSearchNoResult": "No results found in ERP",
      "importCsvTitle": "Import customers from CSV file",
      "importCsvFormat": "Expected format (first row = headers):",
      "importCsvHint": "Columns erp_customer_id and customer_name are required. Existing rows (same erp_id + erp_customer_id) will be updated.",
      "importCsvFile": "CSV file",
      "importCsvLines": "row(s) detected",
      "importCsvSubmit": "Import {{count}} row(s)",
      "importCsvResult": "{{created}} created, {{updated}} updated.",
      "importCsvErrors": "{{count}} error(s):",
      "importCsvErpRequired": "Please select an ERP supplier",
      "erpIdHelp": {
        "default": {
          "placeholder": "ex: CUST-001",
          "help": "Unique customer identifier in the ERP."
        },
        "dolibarr": {
          "placeholder": "ex: 10",
          "help": "Numeric ID of the third party in Dolibarr. Found in the URL of the third-party record (example: ?socid=10)."
        },
        "csv": {
          "placeholder": "ex: CUST-001",
          "help": "Customer identifier as it appears in the customer_id column of your CSV files."
        },
        "salesforce": {
          "placeholder": "ex: 001XX000003ABCDEF",
          "help": "Salesforce Account ID (18 characters). Visible in the Account record URL or via SOQL: SELECT Id, Name FROM Account."
        },
        "business_central": {
          "placeholder": "ex: 10000",
          "help": "Customer number in Business Central (No. field on the Customer card). Found in Customers > customer card > No. field."
        },
        "sage100": {
          "placeholder": "ex: C00001",
          "help": "Customer account number in Sage 100cloud (CustomerNo field). Found in Accounts Receivable > Customer Maintenance > Account No."
        },
        "netsuite": {
          "placeholder": "ex: 1234",
          "help": "Internal ID of the customer record in NetSuite. Found in Lists > Relationships > Customers > Internal ID column."
        },
        "divalto": {
          "placeholder": "ex: CLI-00001",
          "help": "Customer code (Compte tiers) in Divalto Infinity. Found in the customer record under the 'Compte tiers' field."
        },
        "erpnext": {
          "placeholder": "ex: CUST-00001",
          "help": "Customer name (document name) in ERPNext. Found in Selling > Customer > Customer Name field."
        },
        "zoho": {
          "placeholder": "ex: 460000000026049",
          "help": "Customer ID in Zoho Books (contact_id). Found in Contacts > customer record > URL parameter 'contact_id'."
        },
        "cegid": {
          "placeholder": "ex: C00001",
          "help": "Customer account number in Cegid XRP Flex. Found in the customer record under Account > Account Number."
        },
        "bleez": {
          "placeholder": "ex: 12345",
          "help": "Numeric customer account ID in Bleez. Visible in the customer record URL or in the clients list."
        }
      }
    },
    "users": {
      "username": "Username",
      "title": "User Management",
      "addUser": "Add user",
      "colName": "Name",
      "colEmail": "Email",
      "colRole": "Role",
      "colSupplier": "Customer",
      "colStatus": "Status",
      "colLastLogin": "Last login",
      "colActions": "Actions",
      "none": "No users",
      "modalCreate": "Add user",
      "modalEdit": "Edit user",
      "fieldName": "Name",
      "fieldEmail": "Email",
      "fieldRole": "Role",
      "fieldSupplier": "Customer",
      "fieldPassword": "Password",
      "fieldActive": "Active",
      "roleSuperAdmin": "Super Administrator",
      "roleAdmin": "ERP Administrator",
      "roleCustomer": "Customer",
      "cannotEditOwnRole": "You cannot edit your own role.",
      "roleChangeConfirmTitle": "Role change confirmation",
      "roleChangeConfirmMessage": "Do you confirm the role change {{from}} → {{to}} for user: {{user}}?",
      "fieldErp": "Managed ERP",
      "fieldErpPlaceholder": "Select an ERP",
      "deleteConfirm": "Delete user \"{{name}}\"?",
      "resetPassword": "Reset password",
      "sendResetEmail": "Send password reset email",
      "sendResetEmailSuccess": "Password reset email sent to {{email}}",
      "never": "Never",
      "deleteSelectedConfirm": "Delete the {{count}} selected users?",
      "deleteSelected": "Delete selection ({{count}})",
      "colErp": "ERP",
      "viewPermissions": "View permissions",
      "permissionsTitle": "Permissions — {{name}}",
      "permissionsErpAccess": "ERP access",
      "permissionsGroups": "Groups and rights",
      "permissionsNoGroups": "This user does not belong to any group.",
      "permissionsNoErp": "No linked ERP.",
      "permissionsAllStatuses": "All statuses",
      "permissionsCustomStatuses": "Statuses: {{list}}",
      "permissionsCustomer": "ERP customer: {{id}}",
      "permissionsErpType": "Type: {{type}}",
      "fieldPasswordHint": "Leave blank to keep unchanged"
    },
    "logs": {
      "title": "Activity logs",
      "colUser": "User",
      "colAction": "Action",
      "colEntity": "Entity",
      "colDate": "Date",
      "colIp": "IP",
      "none": "No activity recorded",
      "filterUser": "Filter by user",
      "filterAction": "Filter by action",
      "entries_one": "{{count}} entry",
      "entries_other": "{{count}} entries"
    },
    "registrations": {
      "title": "Registration requests",
      "colType": "Type",
      "colCompany": "Company",
      "colContact": "Contact",
      "colErp": "ERP",
      "colDate": "Date",
      "colStatus": "Status",
      "colActions": "Actions",
      "none": "No requests",
      "statusPending": "Pending",
      "statusApproved": "Approved",
      "statusRejected": "Rejected",
      "typeSupplier": "Supplier",
      "typeClient": "Customer",
      "supplierInfo": "Supplier",
      "approve": "Approve",
      "reject": "Reject",
      "rejectReason": "Reason for rejection (optional)",
      "approveConfirm": "Approve this registration request?",
      "rejectConfirm": "Reject this request?"
    },
    "pendingOrders": {
      "title": "Guest orders",
      "subtitle": "Orders placed from the public shop by unregistered users",
      "none": "No guest orders",
      "colDate": "Date",
      "colCustomer": "Customer",
      "colErp": "Supplier",
      "colTotal": "Total incl. tax",
      "colArticle": "Item",
      "colQty": "Qty",
      "colPriceTtc": "Price incl. tax",
      "items": "item(s)",
      "statusPending": "Pending",
      "statusProcessed": "Processed",
      "statusCancelled": "Cancelled",
      "status_pending": "Pending",
      "status_processed": "Processed",
      "status_cancelled": "Cancelled",
      "markProcessed": "Mark as processed",
      "markCancelled": "Cancel",
      "detailTitle": "Guest order",
      "sectionCustomer": "Customer information",
      "sectionCart": "Items ordered",
      "fieldName": "Name",
      "fieldEmail": "Email",
      "fieldPhone": "Phone",
      "fieldCompany": "Company",
      "fieldErp": "Supplier",
      "fieldNotes": "Internal notes",
      "notesPlaceholder": "Add an internal note...",
      "deleteConfirm": "Delete this guest order?",
      "sectionProcess": "Create order in ERP",
      "processHint": "Search for the matching customer in the ERP, then confirm to create the order.",
      "processSelectCustomer": "Search an ERP customer",
      "processSearchPlaceholder": "Customer name, city...",
      "processSubmit": "Create order in ERP",
      "processSending": "Creating...",
      "processSuccess": "Order successfully created in ERP",
      "processRef": "Order reference:",
      "processError": "Error creating the order in the ERP",
      "modeExisting": "Existing customer",
      "modeNew": "New customer",
      "processNewHint": "The information below will be used to create the third-party in the ERP.",
      "processNewName": "Customer name (company or full name)",
      "processSubmitNew": "Create customer & order",
      "processCustomerCreated": "Customer created in ERP:",
      "confirmProcessedTitle": "Approve order",
      "confirmProcessedMessage": "Are you sure you want to mark this order as processed? This action is permanent.",
      "confirmCancelledTitle": "Cancel order",
      "confirmCancelledMessage": "Are you sure you want to cancel this order? This action is permanent.",
      "confirmProcessedBtn": "Yes, approve",
      "confirmCancelledBtn": "Yes, cancel"
    }
  },
  "adminGroups": {
    "title": "User groups",
    "subtitle": "{{count}} group(s)",
    "createGroup": "Create group",
    "editGroup": "Edit group",
    "name": "Name",
    "description": "Description",
    "members": "Members",
    "rights": "Rights",
    "activeGroup": "Active group",
    "nameRequired": "Group name is required",
    "noGroups": "No groups yet — click \"Create group\" to get started",
    "manageGroup": "Manage members and rights",
    "confirmDelete": "Delete group \"{{name}}\"? This action cannot be undone.",
    "tabMembers": "Members",
    "tabRights": "Access rights",
    "selectUser": "Select a user...",
    "addMember": "Add",
    "removeMember": "Remove from group",
    "noMembers": "No members in this group",
    "rightsHint": "Check the modules that members of this group can access. These rights override the ERP configuration for group members.",
    "statusFilter": "Status filter",
    "allStatuses": "All statuses",
    "customStatuses": "Custom statuses",
    "statusPaid": "Paid",
    "statusUnpaid": "Unpaid",
    "statusDraft": "Drafts",
    "statusValidated": "Validated",
    "statusCancelled": "Cancelled",
    "statusSigned": "Signed",
    "statusUnsigned": "Unsigned",
    "statusInProgress": "In progress",
    "statusShipped": "Shipped",
    "statusClosed": "Closed",
    "noModuleWarning": "No module is enabled for this group. Members will have no access to data until at least one module right is granted.",
    "accessRead": "Read only",
    "accessWrite": "Read and write"
  },
  "landing": {
    "signIn": "Sign in",
    "backToTop": "Back to the top of the home page",
    "hero": {
      "badge": "End customers & client-facing teams",
      "title": "One unified space\nfor your customers and your teams",
      "subtitle": "Espace Client is where your end customers meet the teams who support them — order desk, after-sales and sales. Everyone finds the information from your business tools in a single, branded space: invoices, orders, quotes, documents and support.",
      "tagClients": "End customers",
      "tagAdv": "Order desk",
      "tagSav": "After-sales",
      "tagSales": "Sales",
      "cta": "Go to my space"
    },
    "audience": {
      "badge": "Who is it for?",
      "title": "One portal,\ntwo audiences that answer each other",
      "subtitle": "Espace Client is more than a customer extranet: it is also the daily tool of the teams in contact with them. Both sides share the same information, in real time.",
      "clients": {
        "tag": "Audience 1",
        "title": "Your end customers",
        "desc": "They access everything that concerns them on their own, 24/7 — no phone call or e-mail follow-up needed.",
        "point1": "Invoices, quotes and orders available and downloadable at any time",
        "point2": "Online payment and electronic signature of quotes in a few clicks",
        "point3": "Direct ordering from the catalogue, with an AI assistant to find the right product",
        "point4": "Support requests raised and tracked, documents and history centralised"
      },
      "teams": {
        "tag": "Audience 2",
        "title": "Your client-facing teams",
        "desc": "Order desk, after-sales and sales work from the same 360° view as the customer: no more digging through the ERP, e-mails and spreadsheets before answering.",
        "advTitle": "Order desk",
        "advDesc": "Orders land straight in the portal, with no re-keying from e-mails. Delivery and unpaid-invoice tracking included.",
        "savTitle": "After-sales",
        "savDesc": "Every ticket arrives with the full customer context: equipment, servicing, related orders and documents.",
        "salesTitle": "Sales",
        "salesDesc": "Quotes sent, chased and signed from the portal. Immediate visibility on each account activity and outstanding balance."
      }
    },
    "vue360": {
      "badge": "360° view",
      "title": "A 360° view of the customer relationship,\nfor your customers and your teams",
      "subtitle": "The Customer Portal gathers the useful information from your different tools (ERP, CRM, invoicing, support) and presents it to the right person, at the right time.",
      "painTitle": "The problems we solve",
      "pain1Title": "Information silos",
      "pain1Desc": "Customer data is scattered across ERP, CRM, e-mails and spreadsheets — nobody has the full picture.",
      "pain2Title": "Repeated support requests",
      "pain2Desc": "\"Could you resend that invoice?\" Your teams waste time on requests customers could solve on their own.",
      "pain3Title": "Lack of customer visibility",
      "pain3Desc": "Your customers can't see the status of their orders, quotes or invoices — and your teams lack context on every request.",
      "benefitsTitle": "The answer: a 360° view",
      "benefit1Title": "A single entry point for your customers",
      "benefit1Desc": "Invoices, orders, quotes, documents and support gathered in one branded space — real perceived value for the end customer.",
      "benefit2Title": "A unified view for your teams",
      "benefit2Desc": "On a support request, your teams instantly see the customer's orders, pending quotes and unpaid invoices — without switching tools.",
      "benefit3Title": "Integrated with your existing tools",
      "benefit3Desc": "The portal connects to your current ERP/CRM (Dolibarr, Odoo, Salesforce, Sage 100…) — no migration, no double entry."
    },
    "features": {
      "title": "Everything you need",
      "subtitle": "A complete portal to manage your relationship with your supplier, from any device.",
      "invoices": {
        "title": "Invoices & E-Signature",
        "description": "Access all your invoices and quotes in real time. PDF download and electronic signature for commercial proposals."
      },
      "orders": {
        "title": "Orders & Shipments",
        "description": "Track your orders, billing status and shipment progress directly from your account."
      },
      "catalog": {
        "title": "Shop & Product Catalog",
        "description": "Product catalog with variants, filters and images. Public shop with cart and online ordering — no account required."
      },
      "gallery": {
        "title": "Documents & Gallery",
        "description": "All your documents in one place: contracts, delivery notes, certificates. Integrated media gallery."
      },
      "tickets": {
        "title": "Support & Help Desk",
        "description": "Create and track your support requests. Automatic audio transcription for fast incident reporting."
      },
      "revisions": {
        "title": "Revisions & Equipment Fleet",
        "description": "Schedule periodic equipment revisions. Track each individual asset, view intervention history and receive automatic reminders."
      }
    },
    "advantages": {
      "title": "Why choose\nthe Customer Portal?",
      "subtitle": "A modern, secure portal designed to simplify your daily exchanges with your supplier.",
      "secure": "100% secure access (JWT + encryption)",
      "realtime": "Real-time data from your CRM/ERP",
      "compatible": "10+ supported ERPs: Dolibarr, Salesforce, Business Central, Sage 100, NetSuite, Divalto, ERPNext, Zoho One, Cegid and more",
      "responsive": "Responsive interface — PC, tablet, smartphone",
      "available": "Available 24/7, no VPN required",
      "branded": "Customised to your brand and modules"
    },
    "stats": {
      "invoicesLabel": "Invoices available",
      "invoicesValue": "24/7",
      "setupLabel": "Setup time",
      "setupValue": "< 1 hour",
      "erpLabel": "Supported ERPs",
      "erpValue": "10+",
      "securityLabel": "Security",
      "securityValue": "Enterprise grade"
    },
    "erp": {
      "title": "Compatible with your CRM/ERP",
      "subtitle": "Connect your portal to the leading business management solutions in minutes.",
      "dolibarr": "Dolibarr",
      "dolibarrDesc": "Open source ERP, v14+",
      "odoo": "Odoo",
      "odooDesc": "Open source ERP, v16+",
      "salesforce": "Salesforce",
      "salesforceDesc": "Cloud CRM & ERP",
      "bc": "Business Central",
      "bcDesc": "Microsoft cloud ERP",
      "csv": "CSV / Excel",
      "csvDesc": "Flat file import"
    },
    "payment": {
      "badge": "New — Online Payment",
      "title": "Your customers pay their invoices\nin just a few clicks",
      "subtitle": "Your customers settle their invoices directly from the portal by credit card. Funds are automatically transferred to your bank account — no chasing, no manual follow-up.",
      "step1Title": "Customer clicks \"Pay\"",
      "step1Desc": "On any unpaid invoice, a pay button appears directly in the customer portal.",
      "step2Title": "Secure online payment",
      "step2Desc": "Credit card. Transactions are encrypted and protected by 3D Secure — no banking data stored on the portal.",
      "step3Title": "SEPA transfer to your account",
      "step3Desc": "Funds are transferred directly to your IBAN. You collect without any manual action.",
      "trust": "100% secure payment",
      "trustSub": "Bank-grade encryption, 3D Secure, PCI-DSS compliance",
      "recurring": "Recurring payments available",
      "onboarding": "Quick setup — enter your bank details once",
      "noFees": "No fixed fees — commission on transactions only"
    },
    "aiAssistant": {
      "badge": "New — AI Assistant",
      "title": "An AI assistant that guides your customers\nto the right product",
      "subtitle": "In the public shop and the customer catalog alike, your customers describe what they need — typed or spoken — and the AI shows only the matching products.",
      "chatTitle": "Smart chatbot",
      "chatDesc": "\"I'm looking for a wireless headset under €100\": the request is interpreted by AI and the catalog instantly filters down to the relevant products.",
      "voiceTitle": "Built-in voice bot",
      "voiceDesc": "Your customers speak, the assistant listens, understands and answers out loud. Perfect on mobile or on the go.",
      "catalogTitle": "Connected to your catalog",
      "catalogDesc": "The assistant queries your ERP product database live: prices, descriptions and stock are always up to date, with no extra setup."
    },
    "howItWorks": {
      "title": "Up and running in minutes",
      "step1": {
        "title": "Configure your CRM/ERP",
        "desc": "Enter your ERP's URL and API key. The connection is tested automatically."
      },
      "step2": {
        "title": "Invite your customers",
        "desc": "Create your customers' accounts or let them submit an access request via the portal."
      },
      "step3": {
        "title": "Customers get access",
        "desc": "Invoices, orders, quotes, support — everything is available 24/7 without any action on your part."
      }
    },
    "useCases": {
      "badge": "Use cases",
      "title": "What your customers and teams\nactually do with Espace Client",
      "subtitle": "Whatever your industry, the portal fits your existing flows — with no migration and no double entry. Here are six common situations.",
      "contextLabel": "Before",
      "resultLabel": "With Espace Client",
      "uc1": {
        "title": "B2B distribution & wholesale",
        "context": "Your customers reorder the same references over and over and call the order desk to check on their orders.",
        "result": "They reorder in one click from their history, track deliveries in real time and pay invoices online — order-desk calls drop."
      },
      "uc2": {
        "title": "Trades & construction",
        "context": "Your quotes wait days for a paper signature returned by mail or scan.",
        "result": "The customer signs the quote electronically from their phone and finds delivery notes and certificates in a space dedicated to their site."
      },
      "uc3": {
        "title": "Equipment maintenance & after-sales",
        "context": "Periodic services get missed and after-sales requests get lost in emails.",
        "result": "Each piece of equipment has its record, automatic service reminders and an after-sales ticket tracked end to end."
      },
      "uc4": {
        "title": "Services & recurring subscriptions",
        "context": "Every month you chase the same customers over unpaid recurring invoices.",
        "result": "Online payment by card or SEPA plus automatic due-date reminders: payment times shrink effortlessly."
      },
      "uc5": {
        "title": "Industry & key-account suppliers",
        "context": "Your customers want a portal but you won't re-enter ERP data or run a heavy project.",
        "result": "The portal reads orders, deliveries and invoices live in the ERP and handles e-invoicing (PA/PDP) for the 2026 mandate."
      },
      "uc6": {
        "title": "ERP-driven B2B e-commerce",
        "context": "Your catalog lives in the ERP but your customers have no way to order in self-service.",
        "result": "A public branded shop, guest checkout without an account, and an AI assistant (chat + voice) that finds the right product from the described need."
      }
    },
    "faq": {
      "badge": "FAQ",
      "title": "Frequently asked questions",
      "subtitle": "The essentials about Espace Client, its ERP compatibility and its setup.",
      "q1": {
        "q": "What is Espace Client?",
        "a": "Espace Client is a SaaS customer portal that connects in real time to your existing ERP or CRM. Your customers view invoices, orders, quotes and documents, pay online and sign their quotes in a single branded space. Your order-desk, after-sales and sales teams share the same 360° view."
      },
      "q2": {
        "q": "Which ERP or CRM does it work with?",
        "a": "The portal is ERP-agnostic thanks to an adapter system: Dolibarr, Odoo, Salesforce, Microsoft Business Central, Sage 100, NetSuite, Divalto Infinity, ERPNext, Zoho One, Cegid XRP Flex, or a simple CSV/Excel import."
      },
      "q3": {
        "q": "Do I have to migrate my data?",
        "a": "No. No migration: Espace Client reads and writes data directly in your existing ERP. You keep working in your usual tool."
      },
      "q4": {
        "q": "How much does Espace Client cost?",
        "a": "Packs start at €9 excl. tax/month (Starter: 1 user, 50 clients), then €49 (Pro) and €99 (Gold: 10 users, 1,000 clients). An Enterprise plan on quote offers custom quotas, and several packs can be combined."
      },
      "q5": {
        "q": "Can my customers pay invoices online?",
        "a": "Yes, by bank card (3D Secure) or SEPA transfer. Payments are reconciled automatically and due-date reminders go out on their own to reduce late payments."
      },
      "q6": {
        "q": "Is electronic quote signing valid?",
        "a": "Yes. Quotes are signed electronically online via eIDAS-compliant providers; the signed PDF is archived and the status is pushed back automatically to your ERP."
      },
      "q7": {
        "q": "Is it compatible with France's 2026 e-invoicing?",
        "a": "Yes. Espace Client includes PA/PDP connectors (approved platform) for France's e-invoicing reform, with submission tracking."
      },
      "q8": {
        "q": "How long does it take to set up the portal?",
        "a": "A few minutes: enter your ERP's URL and API key, the connection is tested, then invite your customers or let them request access. The portal is then available 24/7 with no intervention."
      }
    },
    "pricing": {
      "navLink": "Pricing",
      "badge": "Pricing",
      "title": "Clear packs, no surprises",
      "subtitle": "Choose the pack that suits your activity. Buy multiple packs to multiply your quotas proportionally.",
      "onQuote": "On quote",
      "customQuotas": "Custom quotas",
      "customValue": "Custom",
      "contactUs": "Contact us",
      "popular": "Popular",
      "perMonth": "/month",
      "billingMultiple": "excl. tax · {{count}} packs × {{price}} €",
      "billingMonthly": "excl. tax · monthly billing",
      "packCount": "Number of packs",
      "start": "Get started",
      "creditsBuyNote": "Quota used up? Buy additional credits at any time from your admin area: they top up your monthly quotas (emails, signatures, AI tokens…) without changing your pack.",
      "creditsNote": "Credit rule: 1 € = 1,000 credits. Credits power email, signature and AI token usage.",
      "quota": {
        "users": "Users",
        "clients": "Clients",
        "signatures": "Signatures",
        "aiTokens": "AI tokens",
        "emails": "Emails/month",
        "catalog": "Online catalog products"
      }
    },
    "cta": {
      "title": "Ready to access your account?",
      "subtitle": "Sign in with your credentials to access your personalised account.",
      "button": "Sign in to my account",
      "registerButton": "Request access",
      "registerHint": "No account yet? Submit a registration request and your supplier will grant you access."
    },
    "footer": "Customer Space — Your secure management portal",
    "footerService": "A service by Iseffi —"
  },
  "seo": {
    "landingTitle": "Espace Client — Customer portal for your clients and your order desk, after-sales and sales teams",
    "landingDescription": "Customer portal connected to your ERP/CRM (Dolibarr, Odoo, Salesforce…): a single space for your end customers and for your order desk, after-sales and sales teams — invoices, orders, quotes, online payment, e-signature and support.",
    "loginTitle": "Sign in — Espace Client",
    "registerTitle": "Request access — Espace Client",
    "shopTitle": "Online shop — Espace Client",
    "shopTitleWithName": "{{name}} shop — Espace Client"
  },
  "shopAssistant": {
    "button": "AI Assistant",
    "buttonTitle": "Search products with the AI assistant",
    "title": "Shop assistant",
    "subtitle": "Describe what you're looking for",
    "listening": "I'm listening…",
    "welcome": "Hello! Describe what you're looking for (typed or spoken) and I'll show you the matching products.",
    "placeholder": "E.g.: a wireless headset under €100",
    "found_one": "I found {{count}} product matching your search. It is now displayed on the page.",
    "found_other": "I found {{count}} products matching your search. They are now displayed on the page.",
    "notFound": "I couldn't find any matching product. Try rephrasing your request.",
    "error": "Sorry, something went wrong. Please try again.",
    "cleared": "Sure, showing the full catalog again.",
    "showAll": "Show all products",
    "activeFilter_one": "AI filter active — {{count}} product displayed",
    "activeFilter_other": "AI filter active — {{count}} products displayed",
    "voiceOn": "Enable voice mode (listening + spoken reply)",
    "voiceOff": "Disable voice mode",
    "speak": "Speak",
    "stopListening": "Stop listening",
    "send": "Send"
  },
  "clientSwitcher": {
    "searchPlaceholder": "Search a client…",
    "typeMore": "Type at least 2 characters…",
    "searching": "Searching…",
    "noResults": "No client found",
    "viewingAs": "Viewing as:",
    "exitClient": "Exit client view"
  },
  "pagination": {
    "show": "Show",
    "perPage": "per page",
    "showing": "{{from}}-{{to}} of {{total}}",
    "noResults": "No results",
    "previous": "Previous page",
    "next": "Next page"
  },
  "darkMode": {
    "toggle": "Toggle dark mode"
  },
  "myTeam": {
    "title": "My team",
    "subtitle": "Manage your organisation's users",
    "inviteUser": "Invite a user",
    "colName": "Name",
    "colEmail": "Email",
    "colRole": "Role",
    "colStatus": "Status",
    "colLastLogin": "Last login",
    "colActions": "Actions",
    "roleUser": "User",
    "roleAdmin": "Administrator",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "deactivate": "Deactivate",
    "activate": "Activate",
    "firstname": "First name",
    "lastname": "Last name",
    "phone": "Phone",
    "inviteNote": "An email will be sent with a temporary password.",
    "noUsers": "No users in your team.",
    "loadError": "Unable to load users.",
    "inviteError": "Error inviting user.",
    "toggleError": "Error updating status.",
    "updateError": "Error updating user.",
    "emailRequired": "Email is required.",
    "roleConfirmTitle": "Remove administrator role",
    "roleConfirmMessage": "Do you confirm removing the administrator role from {{user}}?",
    "lastAdminTitle": "Action not allowed",
    "lastAdminError": "Cannot remove the administrator role: {{user}} is the last administrator of the team."
  },
  "adminProducts": {
    "title": "Product catalog",
    "count": "{{count}} product(s)",
    "noProducts": "No products found."
  },
  "parc": {
    "title": "Equipment fleet",
    "tabSchedules": "Schedules",
    "tabParc": "Fleet",
    "colLabel": "Description",
    "colSerial": "Serial no.",
    "colPurchase": "Purchase date",
    "colLastRevision": "Last revision",
    "colNextRevision": "Next revision",
    "colStatus": "Status",
    "statusActive": "Active",
    "statusEndOfLife": "End of life",
    "statusRetired": "Retired",
    "revise": "Log a revision",
    "revisionDate": "Revision date",
    "revisionNotes": "Notes",
    "history": "Revision history",
    "noHistory": "No revisions recorded.",
    "noEquipment": "No equipment in fleet.",
    "addEquipment": "Add equipment",
    "editEquipment": "Edit equipment",
    "loadError": "Unable to load equipment fleet.",
    "reviseError": "Error saving revision.",
    "ruleAndCustomerRequired": "Revision rule and customer are required."
  },
  "adminUsage": {
    "title": "Usage",
    "subtitle": "Track usage by type and by supplier",
    "dashboardHint": "Signatures, emails, AI tokens — monthly view",
    "months": "months",
    "tabGlobal": "Global view",
    "tabByErp": "By supplier",
    "chartTitle": "Monthly trend",
    "noData": "No data for the selected period.",
    "supplier": "Supplier",
    "esignature": "Electronic signatures",
    "email": "Emails sent",
    "aiTokensClaude": "Claude AI tokens",
    "aiTokensVapi": "Vapi calls (voice)"
  },
  "payment": {
    "pay": "Pay",
    "paid": "Paid",
    "error": "Error creating payment.",
    "confirm": "Confirm payment",
    "modalTitle": "Secure payment",
    "modalDesc": "Invoice",
    "myPaymentsTitle": "My payments",
    "myPaymentsSubtitle": "History of your invoice payments",
    "noPayments": "No payments recorded.",
    "invoiceRef": "Invoice",
    "amount": "Amount",
    "type": "Type",
    "status": "Status",
    "date": "Date",
    "typeOneTime": "One-time",
    "typeSubscription": "Recurring",
    "statusSucceeded": "Paid",
    "statusFailed": "Failed",
    "statusCancelled": "Cancelled",
    "statusPending": "Pending",
    "statusRefunded": "Refunded"
  },
  "migration": {
    "title": "ERP Migration — CSV Export / Import",
    "subtitle": "Export data from one ERP as a pivot CSV, then import it into another ERP. The CSV format is readable and editable in Excel.",
    "modules": "Available modules",
    "module_label": "Module",
    "col": {
      "module": "Module",
      "description": "Description",
      "capabilities": "Capabilities"
    },
    "template": {
      "title": "Download an empty CSV template",
      "help": "The template contains headers and a sample row to guide you when filling in Excel.",
      "btn": "Download template"
    },
    "export": {
      "title": "Export data from an ERP",
      "btn": "Export to CSV"
    },
    "import": {
      "title": "Import data into an ERP",
      "none": "No module supports import in this version.",
      "destination": "(destination)",
      "file": "CSV file",
      "btn": "Import",
      "choose": "Choose a file...",
      "rows": "rows imported",
      "created": "created",
      "updated": "updated",
      "skipped": "skipped",
      "warnings": "warnings",
      "done": "Import complete"
    }
  },
  "status": {
    "common": {
      "unknown": "Unknown"
    },
    "invoice": {
      "paid": "Paid",
      "draft": "Draft",
      "validated": "Validated",
      "abandoned": "Abandoned",
      "cancelled": "Cancelled",
      "late": "Overdue"
    },
    "order": {
      "draft": "Draft",
      "validated": "Validated",
      "shipment_in_progress": "Shipment in progress",
      "shipped": "Shipped",
      "cancelled": "Cancelled"
    },
    "shipment": {
      "draft": "Draft",
      "validated": "Validated",
      "closed": "Closed",
      "cancelled": "Cancelled"
    },
    "ticket": {
      "not_read": "Unread",
      "read": "Read",
      "assigned": "Assigned",
      "in_progress": "In progress",
      "waiting": "Waiting",
      "need_more_info": "Need more info",
      "resolved": "Resolved",
      "closed": "Closed",
      "cancelled": "Cancelled"
    }
  },
  "admin.erps.stripeTitle": "Online payment (Stripe)",
  "admin.erps.stripeHint": "Allow customers to pay invoices directly from the portal.",
  "admin.erps.stripeEnabled": "Enable Stripe payment",
  "admin.erps.stripePublishableKey": "Publishable key (pk_...)",
  "admin.erps.stripeSecretKey": "Secret key (sk_...)",
  "admin.erps.stripeWebhookSecret": "Webhook secret (whsec_...)",
  "admin.erps.stripeCurrency": "Currency",
  "admin.erps.stripeRecurring": "Enable recurring payments",
  "adminBilling": {
    "title": "Subscriptions & Billing",
    "subtitle": "Configure pack-based pricing plans and manage ERP subscriptions",
    "tabs": {
      "plans": "Subscription plans",
      "erps": "ERP subscriptions",
      "costs": "Credit costs"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "quota": {
      "users": "Users",
      "clients": "Clients",
      "signatures": "Signatures",
      "aiTokens": "AI tokens",
      "emails": "Emails",
      "catalogProducts": "Shop products",
      "custom": "Custom"
    },
    "planForm": {
      "titleNew": "New plan",
      "titleEdit": "Edit — {{name}}",
      "nameRequired": "Name is required.",
      "savingError": "Error while saving.",
      "name": "Name *",
      "descriptionFr": "Description (FR)",
      "descriptionEn": "Description (EN)",
      "customPlan": "Quote-based plan (custom quotas)",
      "priceLabel": "Price / pack / month (€)",
      "statusLabel": "Status",
      "statusActive": "Active",
      "statusInactive": "Inactive",
      "usersPerPack": "Users / pack",
      "clientsPerPack": "Clients / pack",
      "signaturesPerPack": "Signatures / pack",
      "aiTokensPerPack": "AI tokens / pack",
      "emailsPerPack": "Emails / pack",
      "catalogPerPack": "Shop products / pack",
      "featuresLabel": "Included features",
      "featuresHint": "(one per line)",
      "featuresPlaceholder": "Priority support\nAPI access\nAdvanced reports",
      "cancel": "Cancel",
      "create": "Create",
      "save": "Save"
    },
    "addCredits": {
      "title": "Credits — {{name}}",
      "invalidAmount": "Invalid amount.",
      "genericError": "Error.",
      "amountLabel": "Amount (€)",
      "reasonLabel": "Reason (optional)",
      "reasonPlaceholder": "Manual addition by administrator",
      "cancel": "Cancel",
      "add": "Add"
    },
    "assignPlan": {
      "title": "Subscription — {{name}}",
      "choosePlanRequired": "Please choose a plan.",
      "quantityMin": "Quantity must be ≥ 1.",
      "genericError": "Error.",
      "planLabel": "Plan",
      "choosePlanOption": "-- Choose a plan --",
      "onQuote": "on quote",
      "packsLabel": "Number of packs",
      "monthlyTotal": "Monthly total:",
      "effectiveQuotas": "Effective quotas",
      "cancel": "Cancel",
      "activate": "Activate"
    },
    "plansTab": {
      "newPlan": "New plan",
      "onQuote": "On quote",
      "perPackPerMonth": "/pack/month",
      "edit": "Edit",
      "deactivate": "Deactivate",
      "confirmDeactivate": "Deactivate plan \"{{name}}\"?",
      "deactivateError": "Error while deactivating.",
      "noPlans": "No plans configured."
    },
    "erpsTab": {
      "refresh": "Refresh",
      "totalErps": "Total ERPs",
      "availableCredits": "Available credits",
      "monthlyValue": "Total monthly value",
      "statusLabel": "Status",
      "nextBilling": "Next billing",
      "creditBalance": "Credit balance",
      "purchasedPacks": "Purchased packs",
      "customValue": "Custom",
      "effectiveQuotas": "Effective quotas",
      "changePlan": "Change plan",
      "addCredits": "Add credits",
      "noErps": "No ERP with subscription found."
    },
    "costsTab": {
      "description": "Number of credits deducted per unit consumed. Conversion rule: <strong>1 € = 1,000 credits</strong>.",
      "colResource": "Resource",
      "colCreditsPerUnit": "Credits / unit",
      "colUnitsPerBilling": "Units / billing",
      "colActive": "Active",
      "noCosts": "No costs configured.",
      "saveCosts": "Save costs"
    },
    "resources": {
      "smtp_email": "Email (SMTP)",
      "sms": "SMS",
      "esignature": "Electronic signature",
      "ai_tokens_claude": "AI tokens (Claude)",
      "ai_tokens_vapi": "Vapi calls (voice)",
      "document_storage": "Document storage",
      "api_calls": "API calls"
    }
  },
  "adminProfile": {
    "title": "Supplier profile",
    "subtitle": "Your company information",
    "loadError": "Unable to load the profile.",
    "saveError": "Error while saving.",
    "saveSuccess": "Profile saved.",
    "save": "Save",
    "saving": "Saving…",
    "sectionCompany": "Company",
    "erpName": "Company name",
    "description": "Description",
    "siren": "SIREN",
    "website": "Website",
    "sectionAddress": "Postal address",
    "address": "Address",
    "postalCode": "Postal code",
    "city": "City",
    "countryCode": "Country (code)",
    "sectionContact": "Contact",
    "contactEmail": "Contact email",
    "contactPhone": "Phone"
  },
  "apiErrors": {
    "userNotLinkedToErp": "User not linked to an ERP.",
    "pleaseSelectClient": "Please select a client.",
    "noClientLinked": "No client associated with this account.",
    "routeNotFound": "Page not found.",
    "erpConnectionError": "ERP connection error.",
    "serverError": "A server error occurred.",
    "connectionError": "Connection error. Please try again.",
    "stripeConnectionError": "Stripe connection error.",
    "unexpectedResponse": "Unexpected server response.",
    "unknown": "An unexpected error occurred."
  },
  "adminHelpTooltips": {
    "title": "Help tooltips",
    "configTitle": "Help tooltips configuration",
    "comingSoon": "This feature will be available soon.",
    "pageTitle": "Configuration help",
    "subtitleSuperAdmin": "Connection guides for all ERPs and client portal usage",
    "subtitleAdmin": "Client portal usage guides",
    "sectionErpLabel": "ERP Connection",
    "sectionUsageLabel": "Client portal usage",
    "badgeComingSoon": "Coming soon",
    "officialDoc": "Official documentation →",
    "footerNote": "Additional sections (user management, catalog, tickets…) will be added soon. If you encounter connection issues, make sure your ERP is accessible from the internet and that the API user has read permissions.",
    "categories": {
      "erp": {
        "title": "Connect your ERP",
        "description": "Prerequisites and steps to connect your ERP to the client portal"
      },
      "users": {
        "title": "User management",
        "description": "Invite, configure and manage your customers' access"
      },
      "invoices": {
        "title": "Invoices and orders",
        "description": "Understand document display and statuses"
      },
      "catalog": {
        "title": "Catalog and shop",
        "description": "Configure the product catalog and online shop"
      },
      "tickets": {
        "title": "Tickets and support",
        "description": "Configure the customer support module"
      }
    },
    "erps": {
      "dolibarr": {
        "tip": "The portal automatically appends /api/index.php to all requests — do not include it in the base URL.",
        "steps": [
          {
            "title": "Enable the REST API module",
            "content": "In Dolibarr, go to Home → Setup → Modules / Applications → Interface. Enable the \"API / Webservices\" (REST) module."
          },
          {
            "title": "Enable the required business modules",
            "content": "Enable the modules corresponding to the features you want in the client portal: Customer Invoices, Orders, Shipments, Products/Services, Third-parties, Tickets/Support depending on the modules enabled in your portal."
          },
          {
            "title": "Create a dedicated API user",
            "content": "Go to Home → Setup → Users and groups → New user. Create a dedicated account (e.g. \"api-portal\"). This avoids tying the API to a personal account."
          },
          {
            "title": "Generate the API key (DOLAPIKEY)",
            "content": "Open the user's profile and click the \"API / Webservices\" tab. Click \"Generate/regenerate external API key\". Copy the generated key — this is your DOLAPIKEY.",
            "code": "DOLAPIKEY"
          },
          {
            "title": "Assign read permissions",
            "content": "In the user's profile, \"Permissions\" tab, make sure the user has read permissions on each enabled module: Third-parties (read), Invoices (read), Orders (read), Products (read), Shipments (read), Tickets (read)."
          },
          {
            "title": "Configure the connection in the portal",
            "content": "Enter the base URL of your Dolibarr instance (e.g. https://my-dolibarr.example.com) and the generated API key. Click \"Test connection\" to validate.",
            "code": "https://my-dolibarr.example.com"
          }
        ]
      },
      "odoo": {
        "tip": "With Odoo, the user's login serves as the \"API key\" and the generated API password replaces the regular password.",
        "steps": [
          {
            "title": "Create a dedicated technical user",
            "content": "In Odoo, go to Settings → Users & Companies → Users. Create a dedicated user (e.g. \"api-portal\") with \"Internal User\" access type."
          },
          {
            "title": "Enable access to required applications",
            "content": "In the user's profile, grant access to the applications used: Sales (orders, quotes), Accounting (invoices), Inventory (shipments), Helpdesk (tickets), Purchases as needed."
          },
          {
            "title": "Generate an API key",
            "content": "Open the user's profile → Preferences (top-right icon) → \"API\" section. Click \"New API Key\", give it a name (e.g. \"client-portal\"), copy the generated key — it will only be shown once."
          },
          {
            "title": "Configure the connection in the portal",
            "content": "Enter the base URL of your Odoo instance (e.g. https://mycompany.odoo.com), the technical user's login, and the API key as the password.",
            "code": "https://mycompany.odoo.com"
          }
        ]
      },
      "bleez": {
        "tip": "Bleez uses OAuth 2.0 Client Credentials — a machine-to-machine flow with no user interaction. The Client ID, Client Secret, and encrypted dossier number are required.",
        "steps": [
          {
            "title": "Retrieve the Client ID and Client Secret",
            "context": "Contact Bleez support to request access to your client_id and client secret."
          },
          {
            "title": "Retrieve the dossier number",
            "context": "In Bleez, go to 'Administration' in the navigation menu, then 'Dossier', and finally 'Paramétrage'."
          },
          {
            "title": "Enter the information in the portal",
            "content": "Fill in the Client ID (API Key), the Client Secret (API Secret), and the dossier number. Also enter your Bleez account login credentials."
          }
        ]
      },
      "salesforce": {
        "tip": "Salesforce uses OAuth 2.0 Client Credentials — a machine-to-machine flow with no user interaction. Only the Client ID and Client Secret are needed, configured via an External Client App.",
        "steps": [
          {
            "title": "Create an External Client App",
            "content": "In Salesforce, go to Setup → search for \"External Client App Manager\". Click \"New External Client App\". Fill in the app name and contact email."
          },
          {
            "title": "Configure OAuth and enable Client Credentials",
            "content": "In the app's OAuth settings, add the \"api\" scope. Then enable \"Enable Client Credentials Flow\". In the \"Run As\" field, select the technical user who will make API calls (they must have permissions on the Salesforce objects used)."
          },
          {
            "title": "Retrieve the Client ID and Client Secret",
            "content": "Save the app and wait a few minutes (Salesforce propagation). Return to the record: the Client ID (Consumer Key) goes in the portal's \"Client ID\" field, and the Client Secret in \"Client Secret\"."
          },
          {
            "title": "Check the \"Run As\" user's permissions",
            "content": "The user designated in \"Run As\" must have access to the required objects: Account (customers), Case (tickets), and depending on your modules: Order (orders), Invoice (invoices). Check via Setup → Profiles or Permission Sets."
          },
          {
            "title": "Enter the Instance URL and API version",
            "content": "The Instance URL is your Salesforce org URL. For a Developer Edition, it looks like https://orgfarm-XXXXXXXX-dev-ed.develop.my.salesforce.com. The recommended API version is v59.0 or higher.",
            "code": "https://orgfarm-XXXXXXXX-dev-ed.develop.my.salesforce.com"
          },
          {
            "title": "Identify your Salesforce customers and tickets",
            "content": "Each portal customer maps to a Salesforce Account (ID format 001XXXXXXXXXXXX, visible in the Account record URL). Tickets map to Salesforce Cases (ID format 5004XXXXXXXXXXXX). These IDs are used to retrieve data via the API."
          }
        ]
      },
      "business_central": {
        "tip": "Business Central uses OAuth 2.0 via Azure AD. You will need the Tenant ID, Environment Name and Company ID.",
        "steps": [
          {
            "title": "Register an application in Azure AD",
            "content": "In the Azure portal (portal.azure.com), go to Azure Active Directory → App registrations → New registration. Name the application (e.g. \"client-portal-bc\") and note the Application (client) ID and Directory (tenant) ID."
          },
          {
            "title": "Create a client secret",
            "content": "In the Azure AD application record → Certificates & secrets → New client secret. Set a duration (12 or 24 months). Copy the secret value immediately — it disappears after closing."
          },
          {
            "title": "Grant API permissions",
            "content": "In API permissions → Add a permission → Dynamics 365 Business Central → Application permissions. Add \"API.ReadWrite.All\" or more specific permissions (Financials, Sales, etc.). Click \"Grant admin consent\"."
          },
          {
            "title": "Retrieve the Environment and Company ID",
            "content": "In Business Central, open the target environment. The URL contains this information: https://api.businesscentral.dynamics.com/v2.0/{tenant_id}/{environment_name}/api/... Also note the Company ID visible in Administration."
          },
          {
            "title": "Configure the connection in the portal",
            "content": "Enter the Tenant ID, Environment Name (e.g. \"Production\"), Company ID, Client ID (Azure Application ID) and Client Secret."
          }
        ]
      },
      "sage100": {
        "tip": "Sage 100 requires the installation and configuration of the Sage API connector on your server. Contact your Sage partner if needed.",
        "steps": [
          {
            "title": "Check the version and API connector",
            "content": "The API connection requires Sage 100 v7.0+ and the Sage REST API module (or a third-party connector). Verify that your licence includes API access and that the service is running on the server."
          },
          {
            "title": "Configure user permissions",
            "content": "In Sage 100, create or designate a technical user with read access on the accounting, sales, purchasing and stock folders depending on the modules enabled in your portal."
          },
          {
            "title": "Generate API credentials",
            "content": "In the Sage 100 admin console, configure API authentication (Basic Auth or Token depending on your version). Note the API server URL, login and password of the technical user."
          },
          {
            "title": "Configure the connection in the portal",
            "content": "Enter the base URL of the Sage 100 API server, the API key (or login) and the secret (or password). Make sure the server is accessible from the portal's hosting environment."
          }
        ]
      },
      "netsuite": {
        "tip": "NetSuite uses OAuth 1.0 with 4 keys: Consumer Key, Consumer Secret, Token ID, Token Secret. All are required.",
        "steps": [
          {
            "title": "Enable REST features",
            "content": "In NetSuite, go to Setup → Company → Features. In the \"SuiteCloud\" tab, enable \"REST Web Services\" and \"Token-Based Authentication (TBA)\"."
          },
          {
            "title": "Create an integration (application)",
            "content": "Go to Setup → Integration → Manage Integrations → New. Name it (e.g. \"client-portal\"), enable \"Token-Based Authentication\". Save and note the Consumer Key and Consumer Secret displayed only once."
          },
          {
            "title": "Create a dedicated API role",
            "content": "In Setup → Users/Roles → Manage Roles → New Role. Grant read permissions on the required lists and transactions (Customers, Invoices, Orders, Items). Enable \"API Only\" for this role."
          },
          {
            "title": "Create an access token",
            "content": "Go to Setup → Users/Roles → Access Tokens → New. Select the created application, technical user and API role. Save and note the Token ID and Token Secret — displayed only once."
          },
          {
            "title": "Configure the connection in the portal",
            "content": "Enter your NetSuite instance URL, Consumer Key, Consumer Secret, Token ID and Token Secret. The NetSuite Account ID is visible in Administration → Account Information."
          }
        ]
      },
      "divalto": {
        "tip": "Divalto Infinity exposes a native REST API. Your Divalto partner can help you configure access rights on business domains.",
        "steps": [
          {
            "title": "Check REST API activation",
            "content": "In Divalto Infinity, verify that the REST API server is active and accessible. This configuration is usually handled by your Divalto partner during deployment."
          },
          {
            "title": "Create a technical user",
            "content": "Create a dedicated user in Divalto with a profile restricted to reading the required domains: Third-parties, Orders, Invoices, Stock depending on your enabled modules."
          },
          {
            "title": "Configure API access rights",
            "content": "In the Divalto admin console, enable API access for this user and grant read permissions on the business domains (Sales, Purchasing, Accounting, Stock)."
          },
          {
            "title": "Configure the connection in the portal",
            "content": "Enter the base URL of your Divalto Infinity server, the API key and the technical user's credentials."
          }
        ]
      },
      "erpnext": {
        "tip": "ERPNext uses token-based authentication (API Key + API Secret) available directly in the Frappe user profile.",
        "steps": [
          {
            "title": "Create a technical user",
            "content": "In ERPNext, go to Settings → Users → New User. Create a dedicated account (e.g. \"api-portal@yourcompany.com\") with the \"System Manager\" role or a custom role."
          },
          {
            "title": "Generate the API key and secret",
            "content": "Open the user's profile. In the \"API Access\" section, click \"Generate Keys\". Copy the API Key and API Secret immediately — the secret is only shown once."
          },
          {
            "title": "Configure role permissions",
            "content": "In ERPNext → Settings → Role Permission Manager, make sure the user's role has read access on the DocTypes: Customer, Sales Invoice, Sales Order, Delivery Note, Item, Issue (Ticket) as needed."
          },
          {
            "title": "Configure the connection in the portal",
            "content": "Enter the base URL of your ERPNext instance (e.g. https://mycompany.erpnext.com), the API Key and API Secret.",
            "code": "https://mycompany.erpnext.com"
          }
        ]
      },
      "zoho": {
        "tip": "Zoho uses OAuth 2.0 via Zoho API Console. Tokens have a limited lifetime and are automatically renewed via the refresh token.",
        "steps": [
          {
            "title": "Create an application in Zoho API Console",
            "content": "Go to api-console.zoho.com → Add Client → \"Server-based Applications\". Enter the application name and the allowed redirect URL. Note the Client ID and Client Secret."
          },
          {
            "title": "Define the required scopes",
            "content": "When generating the token, include the scopes for the modules used: ZohoCRM.modules.ALL (CRM), ZohoBooks.invoices.READ (Invoices), ZohoInventory.invoices.READ (Stock), ZohoDesk.tickets.READ (Support)."
          },
          {
            "title": "Generate the OAuth access token",
            "content": "In Zoho API Console, generate an access and refresh token for your application. The refresh token is permanent and allows automatic access renewal."
          },
          {
            "title": "Configure the connection in the portal",
            "content": "Enter the Client ID (API Key), Client Secret (API Secret) and Refresh Token. Also specify your Zoho account region (.com, .eu, .in, .com.au)."
          }
        ]
      },
      "cegid": {
        "tip": "Cegid XRP Flex is a cloud solution. API activation usually requires intervention from your Cegid contact or reseller.",
        "steps": [
          {
            "title": "Activate API access with Cegid",
            "content": "Contact your Cegid contact or reseller to activate REST API access for Cegid XRP Flex on your tenant. This step is usually performed during initial setup."
          },
          {
            "title": "Create a service account",
            "content": "In the Cegid XRP Flex admin console, create a service account dedicated to the integration with read permissions on the required entities (Customers, Invoices, Orders, Items)."
          },
          {
            "title": "Retrieve API credentials",
            "content": "Obtain your Cegid XRP Flex tenant URL, Client ID and Client Secret provided during API activation. This information is available in the Cegid admin portal."
          },
          {
            "title": "Configure the connection in the portal",
            "content": "Enter the base URL of your Cegid tenant, the API key (Client ID) and API secret (Client Secret). Click \"Test connection\" to validate access."
          }
        ]
      }
    },
    "guides": {
      "users": {
        "tip": "Each invited user receives an email with their login credentials. Remember to check the granted permissions before their first login.",
        "steps": [
          {
            "title": "Access user management",
            "content": "In the Administration menu, click on \"Users\" to display the list of active customer accounts."
          },
          {
            "title": "Invite a new user",
            "content": "Click \"Invite a user\", enter the email address and select the modules they will have access to (invoices, orders, catalog, tickets)."
          },
          {
            "title": "Configure access rights",
            "content": "For each enabled module, choose the access level: read-only or read + actions (e.g. place an order, create a ticket)."
          },
          {
            "title": "Disable or remove access",
            "content": "From the user profile, click \"Disable\" to suspend access without deleting history, or \"Delete\" to permanently remove the account."
          }
        ]
      },
      "invoices": {
        "tip": "Invoice and order statuses are synchronized in real time from your ERP. If there is a discrepancy, use the \"Synchronize\" button in the settings.",
        "steps": [
          {
            "title": "View invoices and orders",
            "content": "The \"Invoices & Orders\" menu lists all available documents. Data comes directly from your ERP via the configured connection."
          },
          {
            "title": "Understand statuses",
            "content": "Each document displays a color-coded status: Pending (grey), In progress (blue), Paid/Delivered (green), Cancelled (red). These statuses reflect the state in your ERP."
          },
          {
            "title": "Filter and search",
            "content": "Use the search bar and filters (date, status, amount) to quickly find a specific document."
          },
          {
            "title": "Download a document",
            "content": "Click the download icon to the right of a document to get the PDF. This feature requires your ERP to expose documents for download."
          }
        ]
      },
      "catalog": {
        "tip": "Catalog synchronization may take a few minutes after a change in your ERP. Refresh the page if new products do not appear.",
        "steps": [
          {
            "title": "Browse the catalog",
            "content": "The \"Catalog\" menu displays the products and services available, as defined in your ERP. Availability and prices reflect the real-time state."
          },
          {
            "title": "View a product page",
            "content": "Click on a product to display its details: description, unit price, available stock, estimated delivery time."
          },
          {
            "title": "Place an order",
            "content": "Add items to your cart, check quantities, then click \"Place order\". The order is sent directly to your ERP."
          },
          {
            "title": "Track an order",
            "content": "Orders placed through the portal appear in the \"Invoices & Orders\" section with the status updated from your ERP."
          }
        ]
      },
      "tickets": {
        "tip": "Tickets are visible on both sides: your teams find them directly in your ERP or support tool, while the customer tracks them in their portal.",
        "steps": [
          {
            "title": "Create a ticket",
            "content": "In the \"Support\" menu, click \"New ticket\". Enter the subject, problem description and priority level. You can attach files if necessary."
          },
          {
            "title": "Track progress",
            "content": "The ticket list displays the status of each request: Open, In progress, Waiting for reply, Resolved, Closed."
          },
          {
            "title": "Reply to a ticket",
            "content": "Open an existing ticket and use the reply field to add a message or additional information. Your teams are automatically notified."
          },
          {
            "title": "Close a ticket",
            "content": "Once the issue is resolved, the ticket can be closed by your team or automatically after an inactivity period defined in the settings."
          }
        ]
      }
    }
  },
  "notifications": {
    "title": "Notifications",
    "markAllRead": "Mark all as read",
    "helpTitle": "What notifications can I receive?",
    "helpTypesUser": [
      "New invoice available",
      "New proposal sent",
      "New document shared",
      "Payment reminder (overdue invoice)",
      "Signature reminder (pending proposal)"
    ],
    "helpTypesAdmin": [
      "New invoice (all your clients)",
      "New proposal (all your clients)",
      "New shared document",
      "Overdue payment reminder",
      "Pending signature reminder"
    ],
    "helpTypesSuperAdmin": [
      "New ERP registration request",
      "Quota exceeded (emails, signatures, AI…)",
      "Low credits on an ERP account"
    ]
  },
  "webhookConfig": {
    "sectionTitle": "ERP Webhooks",
    "sectionSubtitle": "Receive Dolibarr events (new invoices, proposals, signatures) in real time.",
    "urlLabel": "Webhook URL to configure in your ERP",
    "urlHint": "Copy this URL entirely — it includes the secret key. If you regenerate, remember to update Dolibarr.",
    "secretLabel": "Secret key (included in URL)",
    "secretWarning": "The key is embedded in the URL. If you regenerate it, the old URL will stop working — update Dolibarr immediately.",
    "reveal": "Reveal",
    "hide": "Hide",
    "regenerate": "Regenerate key",
    "regenerateConfirm": "Regenerate the secret key? The old key will be immediately invalidated and Dolibarr will stop sending webhooks until updated.",
    "guideTitle": "Configuration in Dolibarr",
    "guideSteps": [
      "Home → Setup → Modules → search 'Webhooks' → enable the module",
      "Home → Setup → Webhooks → click the gear icon on the Webhooks module to open 'Webhook configuration' → 'Targets' tab → click '+' to create a new target",
      "In the 'Url' field, paste the URL shown above (the secret token is already included — do not modify it)",
      "Set the 'Type' field to 'Cancel transaction on error'",
      "Set the 'State' field to 'Automatic trigger'",
      "In 'Triggerable events', click 'Add' and enter the codes from the list below one by one",
      "Save — notifications will arrive in real time from the next event onwards",
      "If Dolibarr shows an error 'httpcode=400' the first time, contact your system administrator (network configuration required in development)"
    ],
    "eventsLabel": "Triggerable events to configure:",
    "eventInvoice": "BILL_VALIDATE — invoice validated → client notification",
    "eventInvoiceModify": "BILL_MODIFY — invoice modified → client notification",
    "eventProposal": "PROPAL_VALIDATE — proposal validated → client notification",
    "eventProposalSent": "PROPAL_SENTBYMAIL — proposal sent by email → client notification",
    "eventProposalModify": "PROPAL_MODIFY — proposal modified → client notification",
    "eventSigned": "PROPAL_CLOSE_SIGNED — proposal accepted → admin alert",
    "eventRefused": "PROPAL_CLOSE_REFUSED — proposal refused → admin alert"
  },
  "notifRules": {
    "title": "Notification Rules",
    "subtitle": "Configure the automatic reminder frequency per service type.",
    "selectErp": "Select an ERP",
    "chooseErp": "-- Choose an ERP --",
    "serviceEsignature": "E-Signature — Signature reminders",
    "serviceInvoice": "Invoices — Overdue reminders",
    "initialDelay": "Initial delay (after the event)",
    "reminderInterval": "Interval between reminders",
    "maxReminders": "Max reminders",
    "maxRemindersHint": "0 = unlimited",
    "days": "days",
    "enable": "Enable",
    "disable": "Disable",
    "savedOk": "Rule saved.",
    "saveError": "Error while saving.",
    "loadError": "Unable to load rules.",
    "manualTrigger": "Manual trigger",
    "manualTriggerDesc": "Immediately sends pending signature reminders based on the configured rules.",
    "triggerBtn": "Send reminders now",
    "triggerOk": "Reminders processed — sent: {{sent}}, skipped: {{skipped}}, failed: {{failed}}.",
    "triggerError": "Error while triggering reminders."
  },
  "acceptInvitation": {
    "title": "Create your account",
    "subtitle": "You have been invited by {{company}} (via {{erp}}) to access your client portal.",
    "proposalHint": "A proposal is waiting for your signature and will be shown after account creation.",
    "noToken": "Invitation link missing or invalid.",
    "invalidToken": "This invitation link has expired or has already been used.",
    "errorTitle": "Invalid link",
    "passwordHint": "Minimum 8 characters.",
    "confirmPassword": "Confirm password",
    "passwordTooShort": "Password must be at least 8 characters.",
    "passwordMismatch": "Passwords do not match.",
    "submitBtn": "Create my account",
    "submitError": "An error occurred. Please try again."
  },
  "legal": {
    "nav": {
      "mentions": "Legal notice",
      "privacy": "Privacy policy",
      "cgu": "Terms of use",
      "cgv": "Terms of sale"
    }
  }
}
